export default {
    "1": "切换会话",
    "2": "切换会话并滚动值顶部",
    "3": "定位某一条会话功能",
    "4": "定位某一条准确消息功能",
    "5": "定位某一条会话不需要检查群公告编辑状态以及窗口状态",
    "6": "定位某一条会话不需要检查窗口状态",
    "7": "站内信",
    "8": "邮件",
    "9": "短信",
    "10": "全部",
    "11": "企业客户",
    "12": "自然人客户",
    "13": "中介机构",
    "14": "潜在客户",
    "15": "已投客户",
    "16": "初步洽谈",
    "17": "达成合作",
    "18": "协议签署",
    "19": "会计师事务所",
    "20": "律师事务所",
    "21": "资产评估机构",
    "22": "信用评级机构",
    "23": "券商机构",
    "24": "未上市",
    "25": "主板",
    "26": "中小板",
    "27": "创业板",
    "28": "新三板",
    "29": "科创板",
    "30": "其他",
    "31": "自然人",
    "32": "法人",
    "33": "已通过",
    "34": "审批中",
    "35": "未通过",
    "36": "已撤销",
    "37": "有条件通过",
    "38": "暂缓表决",
    "39": "普通",
    "40": "紧急",
    "41": "非常紧急",
    "42": "正常",
    "43": "已逾期",
    "44": "未完成",
    "45": "已完成",
    "46": "已关闭",
    "47": "未读",
    "48": "已读",
    "49": "登录状态已失效需要跳到登录页面",
    "50": "登录过期，请重新登录！",
    "51": "网络异常！",
    "52": "项目id不存在 如果看到此错误 请在群里说一下复现步骤",
    "53": "userId为空 如果看到此错误 请在群里说一下复现步骤",
    "54": "任务已删除",
    "55": "名称中不能包含下列特殊字符“\\\\/:*?\"<>|”",
    "56": "暂无对应权限，请联系管理员！",
    "57": "当前无选中文件或文件夹",
    "58": "独立窗口数量已达上限，请关闭其他已打开窗口再操作",
    "59": "项目不存在",
    "60": "组织不存在",
    "61": "荣大XB文件不允许更新版本，请选择重命名或跳过",
    "62": "存在文件与文件夹重名，请选择重命名或跳过",
    "63": "提示",
    "64": "确定要取消上传所有文件吗？",
    "65": "确定",
    "66": "取消",
    "67": "文件已被删除",
    "68": "确定解除「手动锁定」的文件吗？",
    "69": "解除锁定后将通过站内信向锁定人「{}」发送文件解锁提醒。确定继续解锁吗？",
    "70": "解锁",
    "71": "暂无权限解除他人「手动锁定」的文件",
    "72": "请联系锁定人 【{}】进行解除锁定",
    "73": "解锁失败",
    "74": "我知道了",
    "75": "确定（{}秒）",
    "76": "确定要解锁该文件吗？",
    "77": "该文件可能正在编辑，解锁后，完成的版本需要手动上传，同时手动上传的版本内容将覆盖他人编辑的内容，确定要解锁吗？",
    "78": "确定解锁此文件吗？",
    "79": "检测到此文件未在编辑状态，文件锁定异常。",
    "80": "如确定文件正在编辑，请在完成编辑后检查文件已更新为编辑内容。确定继续解锁吗？",
    "81": "暂无权限解除他人正在进行「本地编辑」的文件。",
    "82": "不支持手动解除「审批中/审批通过」的文件",
    "83": "当文件审批被驳回或审批通过后，发起修订时将自动解锁",
    "84": "此文件正在被{}人编辑，不支持解锁他人正在进行「在线编辑」的文件，文件将在所有人完成编辑后自动解锁。",
    "85": "文件锁定异常，且无人正在编辑当前文件，确定要继续解锁吗？",
    "86": "文件锁定异常，且无人正在编辑当前文件，请联系项目管理员进行解锁",
    "87": "联系项目管理员",
    "88": "此文件已被系统锁定，可以预览/只读方式打开！",
    "89": "如需要编辑文件，请下载文件至本地。",
    "90": "此文件已经被",
    "91": "锁定，可以预览/只读方式打开！",
    "92": "文件大于 1G 不支持在线编辑！",
    "93": "文件正在进行本地编辑，请先保存后再进行在线编辑操作！",
    "94": "知道了",
    "95": "该文件已锁定，解锁后才能进行编辑，确定要解锁并进行编辑吗？",
    "96": "该文件格式不支持在线编辑，请通过本地编辑或下载后编辑！",
    "97": "文件正在进行在线编辑，请先保存后再进行本地编辑操作！",
    "98": "参数校验失败，请联系管理员！",
    "99": "网络异常",
    "100": "荣大智慧云",
    "101": "预览",
    "102": "该文件类型暂不支持预览，请下载查看！",
    "103": "【荣大智慧云】的下载文件.xlsx",
    "104": "文档导出错误",
    "105": "搜狗",
    "106": "当前项目已终止，不可进行此操作",
    "107": "服务繁忙，请稍后重试",
    "108": "获取行业分类错误， \\'{}",
    "109": "正在打开页面。。。",
    "110": "获取媒体信息错误，请稍后再试。",
    "111": "编辑",
    "112": "只读查看",
    "113": "请下载查看！",
    "114": "是否通过本地应用打开查看？",
    "115": "是否下载到本地？",
    "116": "下载",
    "117": "只读打开",
    "118": "此文件类型暂不支持编辑与预览，可通过“只读”方式打开文件或将文件下载至本地查看。",
    "119": "只读",
    "120": "当前上传图片已超过最大限制",
    "121": "今天",
    "122": "昨天",
    "123": "前天",
    "124": "MM月DD日",
    "125": "YYYY年MM月DD日",
    "126": "该附件已被删除",
    "127": "我的日志",
    "128": "确定要复用日志吗？",
    "129": "确定要新建日志吗？",
    "130": "有正在编辑的草稿内容，该操作将清空已有的草稿内容，确定继续操作吗？",
    "131": "编辑草稿",
    "132": "网络异常，请刷新重试",
    "133": "共移动 {} 个文件",
    "134": "我是目标文件",
    "135": "目标文件夹与源文件夹相同",
    "136": "目标文件夹含有源文件夹的子文件夹",
    "137": "目标文件夹为\"全部\"文件夹",
    "138": "文件无法操作，已选中的文件或文件夹包含已锁定状态",
    "139": "选中数量超过{}条，请减少操作数量",
    "140": "移动 {} 个文件",
    "141": "发送指定聊天",
    "142": "发送至项目聊天",
    "143": "全局检索",
    "144": "无对应权限，请联系对应项目组负责人处理",
    "145": "系统异常，请刷新重试",
    "146": "当前无权限",
    "147": "{}已存在",
    "148": "文件夹",
    "149": "文件",
    "150": "\"{}\"于{}正在编辑文件",
    "151": "\"{}\"于{}锁定文件",
    "152": "{}审批通过已被锁定",
    "153": "\"{}\"于{}对该{}发起审批",
    "154": "“{}”正在进行在线编辑，于“{}”发起",
    "155": "未正常退出，请重新双击进入编辑，待所有人再次退出后系统自动解锁",
    "156": "多人在线编辑模式",
    "157": "单人本地编辑",
    "158": "该文件切换模式错误，请检查网络无问题后重试",
    "159": "当前最多仅支持选择 {} 人，超出人员不计入选择！",
    "160": "文件夹名称包含特殊字符，请修改文件夹名称后再上传",
    "161": "文件名称包含特殊字符，请修改文件名称后再上传",
    "162": "无内容",
    "163": "文件超出下载限制（已超出600MB/不支持多文件下载），建议使用荣大智慧云客户端进行下载",
    "164": "未检测到荣大智慧云客户端，如果未安装客户端，请先下载安装",
    "165": "下载荣大智慧云客户端",
    "166": "重新检测本地客户端",
    "167": "下载Apple芯片版本",
    "168": "下载Intel芯片版本",
    "169": "正在启动，请稍后",
    "170": "附件",
    "171": "删除失败",
    "172": "已选中的内容中包含已锁定的文件，请先解锁后再进行删除",
    "173": "去解锁",
    "174": "请先加入项目群",
    "175": "消息",
    "176": "项目",
    "177": "文档",
    "178": "任务",
    "179": "工作台",
    "180": "通讯录",
    "181": "投关",
    "182": "应用中心",
    "183": "项目列表",
    "184": "项目归档库",
    "185": "项目终止库",
    "186": "项目回收站",
    "187": "标签管理",
    "188": "项目文档",
    "189": "底稿视图",
    "190": "回收站",
    "191": "文件收藏",
    "192": "个人网盘",
    "193": "我的任务",
    "194": "项目任务",
    "195": "主页",
    "196": "项目统计",
    "197": "日历表",
    "198": "待办事项",
    "199": "我的审批",
    "200": "我的会议",
    "201": "我的投票",
    "202": "我的客户",
    "203": "客户联系人",
    "204": "拜访记录",
    "205": "项目成员",
    "206": "项目日志",
    "207": "项目信息",
    "208": "项目审批",
    "209": "项目会议",
    "210": "项目投票",
    "211": "打开独立窗口",
    "212": "从导航栏移除",
    "213": "设为首页打开",
    "214": "显示应用名称",
    "215": "自定义导航菜单",
    "216": "定位",
    "217": "另存为",
    "218": "打开",
    "219": "投票详情",
    "220": "所属项目",
    "221": "投票名称",
    "222": "投票类型",
    "223": "投票时间",
    "224": "提醒方式",
    "225": "投票人员",
    "226": "抄送人员",
    "227": "日程名称",
    "228": "人员",
    "229": "时间",
    "230": "重复",
    "231": "内容",
    "232": "抄送人",
    "233": "任务详情",
    "234": "任务名称",
    "235": "截止时间",
    "236": "项目名称",
    "237": "状态",
    "238": "创建时间",
    "239": "会议详情",
    "240": "参会人员",
    "241": "列席人员",
    "242": "会议主题",
    "243": "会议类型",
    "244": "会议地点",
    "245": "会议抄送人",
    "246": "会议内容",
    "247": "日程",
    "248": "投票",
    "249": "会议",
    "250": "日志",
    "251": "修改",
    "252": "无提醒",
    "253": "提前15分钟",
    "254": "提前1小时",
    "255": "提前3小时",
    "256": "提前1天",
    "257": "不重复",
    "258": "每天",
    "259": "每周",
    "260": "每年",
    "261": "工作日",
    "262": "不提醒",
    "263": "截至前15分钟",
    "264": "截至前1小时",
    "265": "截至前3小时",
    "266": "截至前1天",
    "267": "剪切",
    "268": "复制",
    "269": "重命名",
    "270": "删除",
    "271": "粘贴",
    "272": "预览打开",
    "273": "多人编辑",
    "274": "通过浏览器在线打开该文件，支持多人同时编辑",
    "275": "发送到指定聊天",
    "276": "发送到项目聊天",
    "277": "发送到聊天",
    "278": "Excel格式",
    "279": "外链分享",
    "280": "生成文件链接，任意人员可通过该链接预览、下载该文件",
    "281": "上传新版本",
    "282": "版本",
    "283": "属性",
    "284": "操作日志",
    "285": "锁定",
    "286": "锁定当前文件，文件被锁定后他人不可编辑",
    "287": "保存到个人网盘",
    "288": "解除锁定，编辑过程中不建议解锁，否则将导致现有编辑内容无法保存上传",
    "289": "添加至「文件收藏」",
    "290": "批量上锁",
    "291": "批量解锁",
    "292": "解锁当前所选文件,以及文件夹下所有的文件",
    "293": "文件审批",
    "294": "文件标签",
    "295": "关联底稿",
    "296": "文件审批意见",
    "297": "文件修订",
    "298": "关联索引列表",
    "299": "设置提醒",
    "300": "核查备注",
    "301": "本地编辑",
    "302": "使用本地编辑器打开该文件，仅支持单人编辑",
    "303": "打开任务",
    "304": "新建文件夹",
    "305": "新建任务文件夹",
    "306": "上传文件",
    "307": "上传文件夹",
    "308": "Word文档",
    "309": "Excel表格",
    "310": "PPT演示",
    "311": "导出清洁版",
    "312": "新建文件",
    "313": "目录审批",
    "314": "目录审批意见",
    "315": "目录修订",
    "316": "更多",
    "317": "下载核查报告",
    "318": "文件工具箱介绍",
    "319": "Excel检验文件目录",
    "320": "Excel提取并复制文件",
    "321": "导出文件目录",
    "322": "文件工具箱",
    "323": "该部门已被删除",
    "324": "有文件正在上传，页面切换或刷新将导致文件上传取消。是否继续？",
    "325": "定制页面切换普通页面",
    "326": "普通页面切换到定制页面",
    "327": "定制页面跳转至定制页面",
    "328": "上市公司",
    "329": "拟上市公司",
    "330": "有限责任公司",
    "331": "股份有限公司",
    "332": "股份合作企业",
    "333": "国有企业",
    "334": "集体所有制",
    "335": "个体工商户",
    "336": "独资企业",
    "337": "有限合伙",
    "338": "普通合伙",
    "339": "外商投资企业",
    "340": "港、澳、台商投资企业",
    "341": "联营企业",
    "342": "私营企业",
    "343": "其他浏览器",
    "344": "项目类型",
    "345": "普通审批",
    "346": "审批流程名称",
    "347": "审批类型",
    "348": "业务类型",
    "349": "项目阶段",
    "350": "流程描述",
    "351": "是否可用",
    "352": "可用",
    "353": "不可用",
    "354": "不可用原因",
    "355": "请输入审批流程名称",
    "356": "请选择审批类型",
    "357": "底稿审批",
    "358": "阶段审批",
    "359": "项目终止审批",
    "360": "新建项目审批",
    "361": "底稿归档审批",
    "362": "底稿借阅审批",
    "363": "文件修订审批",
    "364": "底稿目录修订审批",
    "365": "无",
    "366": "项目所属阶段与流程图所属业务类型不匹配",
    "367": "待审文件",
    "368": "请到项目文档中发起审批",
    "369": "项目所属阶段与流程图所属阶段不匹配",
    "370": "当前项目正在进行阶段审核",
    "371": "这是个错误提示！",
    "372": "这是个正确提示！",
    "373": "当前账号在其他设备登录，如果不是本人操作，请及时修改登录密码",
    "374": "登录状态已失效，需要跳转登录页面重新登录",
    "375": "图片",
    "376": "群公告",
    "377": "分享了一个任务",
    "378": "重置数据",
    "379": "单独设置某一个会话",
    "380": "批量设置会话操作",
    "381": "单条会话移除",
    "382": "免打扰状态切换",
    "383": "接受某条消息后处理",
    "384": "重新登录后对托盘所有消息进行重置",
    "385": "会话已读的操作,需要删除与sessionid相关忽略、@消息、托盘等数据",
    "386": "全部任务",
    "387": "全部项目",
    "388": "消息会话",
    "389": "消息记录",
    "390": "讨论文件合集",
    "391": "Word文件（非XB）",
    "392": "表格文件",
    "393": "演示文件",
    "394": "PDF文件",
    "395": "TXT文件",
    "396": "图片文件",
    "397": "视频文件",
    "398": "音频文件",
    "399": "荣大XB文件",
    "400": "外部XB文件",
    "401": "其它",
    "402": "有索引的",
    "403": "无索引的",
    "404": "已锁定",
    "405": "有备注的",
    "406": "有标签的",
    "407": "待审批",
    "408": "审批通过",
    "409": "节点审批通过",
    "410": "驳回未修改",
    "411": "驳回已修改",
    "412": "修订中",
    "413": "修订审批中",
    "414": "有关联的",
    "415": "有审批记录的",
    "416": "有设置提醒的",
    "417": "已归档",
    "418": "无文件",
    "419": "有文件",
    "420": "引用目录",
    "421": "非引用目录",
    "422": "项目名称或项目ID",
    "423": "项目创建人",
    "424": "选择部门",
    "425": "项目地区",
    "426": "当前阶段",
    "427": "创建日期",
    "428": "关联客户",
    "429": "关联项目",
    "430": "行业分类",
    "431": "项目负责人",
    "432": "文件名称",
    "433": "标题关键词",
    "434": "内容关键词",
    "435": "文件类型",
    "436": "文件状态",
    "437": "目录状态",
    "438": "修改时间起",
    "439": "修改时间止",
    "440": "创建人",
    "441": "执行人",
    "442": "优先级",
    "443": "逾期状态",
    "444": "任务状态",
    "445": "任务时间起",
    "446": "任务时间止",
    "447": "日志标题",
    "448": "日志内容",
    "449": "发出人员",
    "450": "日志状态",
    "451": "日志评论",
    "452": "日志评论人",
    "453": "日志接收人",
    "454": "个人日志",
    "455": "客户编码",
    "456": "客户名称",
    "457": "客户类型",
    "458": "客户状态",
    "459": "上市板块",
    "460": "客户负责人",
    "461": "客户创建人",
    "462": "机构编码",
    "463": "机构名称",
    "464": "机构简称",
    "465": "机构类型",
    "466": "部门",
    "467": "职务",
    "468": "拜访开始时间",
    "469": "拜访结束时间",
    "470": "拜访地点",
    "471": "拜访人员",
    "472": "拜访形式",
    "473": "主要成果",
    "474": "请输入项目名称,多个请用空格隔开",
    "475": "请选择项目成员",
    "476": "请选择阶段",
    "477": "点击选择项目创建人",
    "478": "点击选择项目负责人",
    "479": "请选择起始时间",
    "480": "请选择终止时间",
    "481": "请输入客户名称,多个请用空格隔开",
    "482": "共 {} 条 (最多可查看前 10,000 条数据)",
    "483": "共 {} 条",
    "484": "我的联系人",
    "485": "客户管理",
    "486": "联系人管理",
    "487": "联系人信息查阅授权",
    "488": "通讯录操作记录",
    "489": "正在粘贴...",
    "490": "摘要",
    "491": "外链",
    "492": "不限大小",
    "493": "10M以内",
    "494": "大于100M",
    "495": "自定义",
    "496": "第一步：点击「新建任务」",
    "497": "在这里可以开始新建任务并进行网查任务相关的配置信息",
    "498": "第二步：输入任务基本信息",
    "499": "在这里你可以输入需要进行的网查任务名称，并将该任务与项目进行关联",
    "500": "第三步：下载并导入网查清单",
    "501": "1、将下载模板后，按照对应格式填写相关信息，再将完善好的表格进行上传",
    "502": "2、选择各个分类下所需要查询的省市级网站及海关信息，完成配置后点击「确定并继续」",
    "503": "第四步：配置查询网站",
    "504": "在这里你可以选择不同分类下需要查询的网站，或添加其他网站，完成后点击「确认并继续」",
    "505": "第五步：启动网查任务",
    "506": "任务配置完成后，在当前页面可查看本次任务的查询数量及权益信息，点击「立即启动」后网查任务自动开始",
    "507": "第六步：查看任务详情",
    "508": "在这里你可以查看当前网查任务下查询的子任务的更新状态",
    "509": "第七步：查看完成查询的任务文件",
    "510": "在点击「查看文件」跳转至网查任务所在的项目文件夹",
    "511": "第八步：查看项目文件",
    "512": "已完成查询的任务文件会自动存储在当前项目>智能网查文件夹内。",
    "513": "现在，你已经完成了智能网查工具的核心功能流程使用，现在去创建自己的网查任务吧",
    "514": "转发",
    "515": "新建",
    "516": "任务文件夹",
    "517": "在线模板",
    "518": "目录模板",
    "519": "底稿变动记录",
    "520": "上传",
    "521": "设置上传路径",
    "522": "批量关联底稿",
    "523": "文件内容",
    "524": "请输入文件内容关键字 以空格区分",
    "525": "修改时间",
    "526": "今日",
    "527": "近一周内",
    "528": "近一个月内",
    "529": "近三个月内",
    "530": "近六个月内",
    "531": "近一年内",
    "532": "非",
    "533": "在线编辑",
    "534": "在线预览",
    "535": "XB导出清洁版",
    "536": "内容关键字",
    "537": "多人在线编辑",
    "538": "任务中暂不支持单人本地编辑，请切换到多人在线编辑，或定位至源文件位置操作",
    "539": "目标文件已被锁定，暂不支持编辑，鼠标移入锁图标查看详情。如需继续操作请联系相关人员解锁或下载该文件",
    "540": "请选择至少一条数据",
    "541": "请选择一条数据",
    "542": "文件夹不能预览，请选择文件",
    "543": "审批中的文件不能重命名，请重新选择。",
    "544": "归档文件不可重命名",
    "545": "该文件不允许重命名",
    "546": "文件正在进行在线编辑不能进行此操作",
    "547": "不能包含特殊字符/:*?\"<>|",
    "548": "已有相同名称的{}，是否以 {} 命名{}",
    "549": "目录",
    "550": "重名提示",
    "551": "文件已锁定，不允许上传新版本",
    "552": "归档文件不可上传新版本",
    "553": "文件夹不支持该功能，请选择文件",
    "554": "荣大XB文件不支持查看版本",
    "555": "权限校验失败,请联系管理员",
    "556": "当前项目已终止,不可以进行此操作",
    "557": "文件已经被系统锁定,不允许执行此操作",
    "558": "文件已经归档,不允许执行此操作",
    "559": "当前数据不完整,请联系管理员",
    "560": "智慧投行管理系统",
    "561": "修改密码",
    "562": "切换后台",
    "563": "一键同步",
    "564": "退出登录",
    "565": "个人信息",
    "566": "欢迎您",
    "567": "项目编码",
    "568": "项目状态",
    "569": "操作",
    "570": "上传新文件",
    "571": "初始化",
    "572": "未上传",
    "573": "上传成功",
    "574": "上传失败",
    "575": "初始化完成，等待上传",
    "576": "不同意",
    "577": "不通过",
    "578": "驳回",
    "579": "请输入项目名称",
    "580": "未设置执行人",
    "581": "未设置抄送人",
    "582": "任务时间",
    "583": "当前为内测环境，即将跳转到正式环境，若仍需要使用内测环境，请联系 {} 进行咨询",
    "584": "当前为正式环境，即将跳转到内测环境，若仍需要使用正式环境，请联系 {} 进行咨询",
    "585": "投行机构",
    "586": "创建一个组织/项目",
    "587": "建立一个IPO项目并添加团队成员",
    "588": "欢迎来到智慧云，创建一个组织/项目是开启投行工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置",
    "589": "日常沟通协作",
    "590": "围绕项目文件协作展开的高效沟通",
    "591": "无论是券商收集发行人的申报材料，或发行人准备上市材料等与文件协作相关的场景，都可以通过智慧云的「发送到聊天」功能对项目文件进行针对性的沟通，在消息中讨论的所有过程文件都会被留痕，让工作有源可溯、有迹可循",
    "592": "项目文件管理",
    "593": "收集发行人资料、整理底稿、撰写招股说明书",
    "594": "智慧云预置了最新的项目底稿文件模板，可以在线一键导入，并按照底稿目录的要求实时收集发行人的底稿材料。同时可以对常见文件类型进行在线多人编辑或单人本地编辑，提高文件整理效率",
    "595": "任务分配",
    "596": "通过任务分配把控项目整体进度",
    "597": "创建或导入项目进行中各阶段的任务，方便对项目过程中的事项集中管理，有序规划工作节奏，及时了解项目任务的执行进展，尽早规避潜在风险。成员可以将任务分享至其他成员，与团队成员协作完成任务，共同达成团队目标",
    "598": "实习生管理",
    "599": "对项目角色进行权限分配，将敏感数据有效隔离",
    "600": "在项目承做过程中需要进行数据隔离或不希望部分角色接触到核心数据时，可以在智慧云中通过任务分发的方式进行数据隔离并完成项目任务，或对项目角色进行可操作/查看内容范围的权限配置，对于即将退出或已经退出项目的成员可以做到数据的有效隔离",
    "601": "质控内核",
    "602": "区分过程文件目录与底稿目录，支持文件外批注，支持导出批注",
    "603": "在项目的质控与内核过程中，你可以在智慧云内通过将项目文档按团队或分工的形式建立不同的文件目录开展相对应的工作，通过底稿视图索引项目文件生成底稿目录快速有效的区分过程文件与底稿文件，同时支持对文件进行批注与导出。",
    "604": "专业的应用程序",
    "605": "穿行测试PDF文件解析、智能网查、走访盘点相机、XBRL等应用程序",
    "606": "智慧云「应用中心」是一个精心打造的集成了各种类型与项目相关的应用集合工作台，在这里你可以通过丰富独立的应用程序来解决在项目全流程上的多种业务场景问题，快速整合申报信息从而提高团队工作效率，让成员更省心，管理者更放心",
    "607": "私募基金",
    "608": "建立一个属于自己公司机构类型的组织并添加团队成员",
    "609": "欢迎来到智慧云，创建一个组织/项目是开启基金管理工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置",
    "610": "全生命周期管理",
    "611": "任务清单式的全生命周期项目管理",
    "612": "你可以通过智慧云实现私募基金的全生命周期管理，通过任务式清单建立开放高效的协作体系，在任务看板中即可随时掌握所有产品进度，再多产品并行也能及时把控，任务完成后产出的文件会自动归集为项目文件，过程资料将自动归档，无需事后补充或二次核查，让项目管理更高效",
    "613": "围绕基金产品的项目任务展开内外部高效沟通协作",
    "614": "多部门协作的产品要素表制作或合同要素信息、估值表、投资者信息的分享，都可以通过智慧云在线讨论功能对项目文件进行针对性的沟通，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循。亦或基金合同状态查询，也可通过项目伴生群时时接收最新合同动态",
    "615": "基金合同状态查询",
    "616": "一站式查询所有基金产品合同状态及信息",
    "617": "基金合同或其他文件可以通过项目的形式进行管理，项目创建完成会自动生成对应的项目伴生群，在项目伴生群内有关基金合同的所有信息可以随时随地在手机端或电脑端进行查看实时信息或历史信息",
    "618": "发行人(上市/拟上市公司)",
    "619": "创建一个IPO项目",
    "620": "建立一个企业IPO项目并添加团队成员",
    "621": "欢迎来到智慧云，建立一个组织/项目是开启IPO工作的必要前提，作为组织/项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置",
    "622": "无论是券商机构收集发行人的申报材料，或发行人准备上市材料等与文件协作相关的场景，都可以通过智慧云的「发送到聊天」功能对项目文件进行针对性的沟通，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循",
    "623": "文件高效传递/协作",
    "624": "避免反复向多方提供文件，文件变更后自动同步，无需二次传递",
    "625": "发行人上市过程中忙于经营，在券商机构承做上市申报材料时，为避免包含同一数据或需要反复引用的文件在多方传递或被修改后由于更新版本不一致而影响申报材料制作，可以将所有项目文件在智慧云内进行统一管理，当原始文件数据更新后，所有相关文件将同步更新，避免因文件材料无效而影响整体上市进度",
    "626": "分配任务进行资料收集管理",
    "627": "董秘办分配任务到各部门，附带文件模板，自动归集产出文件",
    "628": "在企业上市前夕需要相关负责人来协调统筹上市工作所需要的所有材料文件，智慧云预置了上市过程中各阶段的任务模板，负责人可以通过任务分享的方式在企业内部快速收集所需的文件材料，分配给执行人的任务可以附带文件模板说明及注意事项，更精确有效的归集文件，任务完成后产出的文件会自动归集为项目文件，省去二次整理的时间，让任务管理更高效",
    "629": "项目文件操作留痕",
    "630": "记录与文件相关的操作，并生成统计简报定期推送",
    "631": "为更好的管理上市前夕内部的材料准备，部门协作人对上级分发的任务完成情况，或项目内文件的操作动态可以通过每日简报获取相关的操作数据，文件留痕使过程容易被追溯",
    "632": "专业应用",
    "633": "董监高辅导验收模拟考试（IPO版驾考宝典）",
    "634": "智慧云「应用中心」是一个精心打造的集成了各种类型与项目相关的应用集合工作台，在这里你可以通过丰富独立的应用程序来解决项目上市过程中的多种业务场景题，快速整合申报信息从而提高团队工作效率，让成员更省心，管理者更放心",
    "635": "企业内部管理",
    "636": "按事物或部门创建项目",
    "637": "创建一个契合你部门或事物的项目并添加团队成员",
    "638": "欢迎来到智慧云，建立一个项目是开启企业内部管理工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在项目的全部权限，可以对不同角色的项目成员进行权限配置",
    "639": "新成员可查看历史消息，提高工作交接效率",
    "640": "智慧云提供了针对项目文件进行的实时讨论功能，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循，为所有参与项目的成员了解历史信息提供了便捷的帮助",
    "641": "基于项目管理文件，持续积累沉淀形成企业内部知识库",
    "642": "智慧云提供了基于项目文件的模板配置功能，你可以通过配置生成统一的文件模板，协作成员可以对文件进行在线同步编辑或单人本地编辑，在不断的积累沉淀过程中形成企业内部的知识库",
    "643": "通过任务分配把控项目整体进度，共同达成团队目标",
    "644": "创建或导入需要工作协同的任务，将任务分享至相关的执行人进行协同，分配给执行人的任务可以附带相关文件说明及注意事项，更精确有效的传达任务目标，任务完成后产出的文件会自动归集为项目文件，在把控团队执行进度的同时，使工作目标可以更有效完成规划",
    "645": "集团客户管理",
    "646": "建立项目层级，管理层级关系复杂的集团客户",
    "647": "对层级关系复杂的企业，可以通过真实的组织架构进行项目分层级管理，使项目预览更加高效，同时对常参与的项目可以进行收藏管理，方便用户一键触达对应项目内",
    "648": "企业管理权限设置",
    "649": "无需参与项目，按部门或按业务类型查阅所有项目",
    "650": "企业管理员可以通过后台管理对组织内不同成员角色进行可访问数据和可操作功能的权限配置，可以有效的对不同成员进行数据隔离，防止潜在风险发生",
    "651": "包含证券公司、律所、会所等机构对投行项目的日常管理操作",
    "652": "基金产品全生命周期管理",
    "653": "项目申报中的文件传递、日常沟通、分配任务等，所有工作都聚合一处",
    "654": "团队及日常工作事物一站式管理",
    "655": "项目设置",
    "656": "项目名备注",
    "657": "添加至收藏",
    "658": "取消收藏",
    "659": "添加至「收藏」",
    "660": "失败",
    "661": "文件名",
    "662": "编辑模式",
    "663": "修改人",
    "664": "大小",
    "665": "文件路径",
    "666": "新建子文件夹",
    "667": "上传新版本成功！",
    "668": "时间从近到远",
    "669": "时间从远到近",
    "670": "文件从大到小",
    "671": "文件从小到大",
    "672": "多文件",
    "673": "编辑打开",
    "674": "文件格式错误，无法另存！",
    "675": "您已不在该组织，请选择其它保存位置",
    "676": "您已不在该项目，请选择其它保存位置",
    "677": "审批流程",
    "678": "请输入审批流程名称,多个请用空格隔开",
    "679": "申请内容",
    "680": "请输入申请内容,多个请用空格隔开",
    "681": "交接人员",
    "682": "审核中",
    "683": "底稿",
    "684": "审批",
    "685": "参考文件",
    "686": "调查工具",
    "687": "自然日",
    "688": "一",
    "689": "二",
    "690": "三",
    "691": "四",
    "692": "五",
    "693": "六",
    "694": "日",
    "695": "截止前15分钟",
    "696": "截止前1小时",
    "697": "截止前3小时",
    "698": "截止前1天",
    "699": "开始前一天",
    "700": "开始时",
    "701": "完成时",
    "702": "应用内消息",
    "703": "Excel文档",
    "704": "PPT文档",
    "705": "Txt文档",
    "706": "确认要把文件放入回收站吗?删除的文件可随时通过回收站还原。",
    "707": "已取消删除",
    "708": "删除成功！",
    "709": "当前页不可重命名",
    "710": "只能重命名一个",
    "711": "请选择想要剪切的文件或文件夹",
    "712": "剪切成功!",
    "713": "复制成功!",
    "714": "当前页不可粘贴",
    "715": "请先复制或剪切",
    "716": "粘贴内容超出网盘容量",
    "717": "可用空间已满",
    "718": "新建{}文档",
    "719": "新建失败",
    "720": "只能对一个文件上传新版本",
    "721": "文件夹不支持上传新版本，请选择文件",
    "722": "解锁文件夹下所有的文件",
    "723": "文件已另存到",
    "724": "去查看",
    "725": "另存失败，请重新操作",
    "726": "文件上传失败",
    "727": "因当前空间不足，导致文件上传失败",
    "728": "因当前空间不足，导致文件上传失败 ；请联系",
    "729": "进行空间查询与管理",
    "730": "空间查询",
    "731": "升级扩容",
    "732": "因当前空间不足，导致文件上传失败；请进行空间查询与管理!",
    "733": "当前只可选择文件",
    "734": "文件较大，正在另存中...",
    "735": "个人网盘空间不足",
    "736": "未选中文件",
    "737": "未选中文件夹",
    "738": "当前目录不可选择,请重新选择目录",
    "739": "讨论文件合集({}项)",
    "740": "等{}个文件,",
    "741": "评论了您的日志",
    "742": "在日志中@了您",
    "743": "回复了您的日志",
    "744": "加载中...",
    "745": "你可以将文件直接拖拽到这里，或者点击",
    "746": "审批催办",
    "747": "查看详情",
    "748": "接收范围",
    "749": "开始时间",
    "750": "结束时间",
    "751": "地址",
    "752": "至",
    "753": "等",
    "754": "限时免费",
    "755": "限时特惠",
    "756": "文件/文件夹数据过多、不支持上传、建议分批多次上传",
    "757": "暂无可查看任务",
    "758": "请前往项目任务查看任务，可同时打开10个任务",
    "759": "查看项目任务",
    "760": "还原",
    "761": "放大",
    "762": "关闭",
    "763": "播放",
    "764": "公告的图片",
    "765": "查看全文",
    "766": "查看",
    "767": "当前文件版本已发生变更，请选择你要操作的文件版本",
    "768": "历史版本",
    "769": "当前版本",
    "770": "[文件]",
    "771": "[文件夹]",
    "772": "打开文件夹",
    "773": "月",
    "774": "最近修改",
    "775": "下载最新文档",
    "776": "讨论文件合集({})项",
    "777": "消息已被撤回",
    "778": "来源于",
    "779": "语音",
    "780": "@所有人",
    "781": "选择执行人",
    "782": "来自",
    "783": "选择开始时间",
    "784": "选择结束时间",
    "785": "任务标签",
    "786": "查看更多",
    "787": "设为前置",
    "788": "取消前置",
    "789": "详情",
    "790": "重新编辑",
    "791": "任务已被删除",
    "792": "点击查看",
    "793": "你",
    "794": "分享了一篇日志",
    "795": "查看全部",
    "796": "评论",
    "797": "】来源于:",
    "798": "讨论",
    "799": "相关任务",
    "800": "文件权限",
    "801": "Txt文本",
    "802": "请切换到主窗口操作此功能",
    "803": "该审批已撤销",
    "804": "您已不在当前审批中，无法查看",
    "805": "关闭和跳转将不会保存你已编辑的群公告内容?",
    "806": "上传失败,仅文件列表区域支持拖拽上传",
    "807": "退出成功!",
    "808": "根目录",
    "809": "XB功能暂不支持使用",
    "810": "您好，您的XBRL已到期。请注意数据中心词条数据将不会同步至XB文档，请及时联系对应商务续费谢谢！",
    "811": "后续不再提示",
    "812": "正在加载...",
    "813": "本科",
    "814": "后退",
    "815": "前进",
    "816": "返回上一级",
    "817": "创建文件夹",
    "818": "联系人/群组",
    "819": "聊天记录",
    "820": "聊天记录中的文件",
    "821": "视频",
    "822": "音频",
    "823": "{}正在播放—荣大智慧云",
    "824": "页面访问权限",
    "825": "查看权限",
    "826": "新建权限",
    "827": "编辑权限",
    "828": "下载与分享权限",
    "829": "文档管理权限",
    "830": "客户权限",
    "831": "联系人权限",
    "832": "通讯录管理权限",
    "833": "项目信息查看",
    "834": "有权访问查看项目信息页面",
    "835": "标签信息编辑",
    "836": "有权编辑项目信息中的标签值",
    "837": "项目信息编辑",
    "838": "有权编辑项目信息内容",
    "839": "中介机构关联",
    "840": "有权增加/移除项目中介机构，并关联机构下相关联系人",
    "841": "联系人查看",
    "842": "有权查看已关联到项目的联系人信息，同时需要拥有组织角色中联系人的查看权限",
    "843": "项目成员管理",
    "844": "有权访问项目【成员管理】页面",
    "845": "成员邀请",
    "846": "有权邀请人员加入当前项目",
    "847": "成员移除",
    "848": "有权移除项目成员",
    "849": "成员加入审核",
    "850": "有权通过/拒绝人员提出加入项目的申请",
    "851": "成员角色设置",
    "852": "有权修改或赋予成员的项目角色，调整成员在项目内的操作权限",
    "853": "项目角色管理",
    "854": "有权访问项目【角色权限】页面",
    "855": "角色权限编辑",
    "856": "有权修改/配置项目角色在项目中的可操作功能",
    "857": "项目角色创建",
    "858": "有权创建新的项目角色",
    "859": "项目角色重命名",
    "860": "有权修改项目角色名称",
    "861": "项目角色删除",
    "862": "有权删除项目角色",
    "863": "项目任务访问",
    "864": "有权访问项目任务页面，查看项目中的任务列表",
    "865": "任务/子任务创建",
    "866": "有权在任务列表中创建新任务，在任务中创建子任务，在文档中创建任务文件夹",
    "867": "全部任务访问",
    "868": "有权查看项目内所有任务信息，无论是否作为任务执行人或被抄送",
    "869": "全部任务编辑",
    "870": "有权编辑项目内所有任务信息，无论是否作为任务执行人或被抄送",
    "871": "全部任务关闭",
    "872": "有权关闭项目内所有任务数据，无论是否作为任务执行人",
    "873": "全部任务删除",
    "874": "有权删除项目内所有任务数据，无论是否作为任务执行人",
    "875": "任务标签管理",
    "876": "有权新增或修改项目内的任务标签",
    "877": "任务工时管理",
    "878": "有权在任务中，设置更新他人任务工时",
    "879": "项目日志访问",
    "880": "有权访问项目日志列表，查看项目内日志数据",
    "881": "项目日志创建",
    "882": "有权在项目中创建新日志，或在【我的日志】中创建所属此项目的日志",
    "883": "项目日志导出",
    "884": "有权将项目日志数据内容导出下载到本地或保存到项目文档",
    "885": "项目日志总览",
    "886": "有权查看项目内所有日志数据，无论是否被抄送",
    "887": "项目会议访问",
    "888": "有权访问查看项目会议列表",
    "889": "项目会议创建",
    "890": "有权在此项目中创建新会议",
    "891": "项目会议编辑",
    "892": "有权在此项目中编辑会议内容",
    "893": "项目会议删除",
    "894": "有权在此项目中删除会议数据",
    "895": "项目会议导出",
    "896": "有权在此项目中导出会议列表",
    "897": "项目投票访问",
    "898": "有权访问查看项目投票列表",
    "899": "项目投票创建",
    "900": "有权在此项目中创建新的投票",
    "901": "项目投票编辑",
    "902": "有权在此项目中编辑投票内容",
    "903": "项目投票删除",
    "904": "有权在此项目中删除投票记录",
    "905": "项目投票导出",
    "906": "有权在此项目中导出投票列表",
    "907": "项目文档访问",
    "908": "有权访问项目中项目文档页面，文件操作权限以配置为准",
    "909": "底稿视图访问",
    "910": "有权访问项目中底稿视图页面，文件操作权限以配置为准",
    "911": "回收站访问",
    "912": "文件预览",
    "913": "在项目文档与底稿视图中，有权预览打开文件",
    "914": "历史版本预览",
    "915": "在项目文档与底稿视图中，有权预览打开文件的历史版本",
    "916": "文件只读",
    "917": "在项目文档与底稿视图中，有权只读打开文件",
    "918": "历史版本只读",
    "919": "在项目文档与底稿视图中，有权只读打开文件的历史版本",
    "920": "文档创建",
    "921": "有权在当前项目文档与底稿视图中新建文件/文件夹/文件目录",
    "922": "文档上传",
    "923": "有权从本地上传文件/文件夹至项目文档或底稿视图",
    "924": "文档粘贴",
    "925": "有权从别的项目/组织中粘贴文件至当前项目文档或底稿视图",
    "926": "本地/在线编辑",
    "927": "有权在项目文档与底稿视图中进行本地/在线编辑文件",
    "928": "文档重命名",
    "929": "有权在项目文档与底稿视图中修改文件/文件夹名称",
    "930": "新版本上传",
    "931": "有权在项目文档与底稿视图中通过本地上传更新文件版本",
    "932": "历史版本还原",
    "933": "有权在项目文档与底稿视图中使用文件历史版本替代当前版本",
    "934": "文档删除",
    "935": "有权在项目文档与底稿视图中进行文件/文件夹删除",
    "936": "文档剪切",
    "937": "有权在项目文档与底稿视图中对文件/文件夹进行剪切操作",
    "938": "有权在底稿视图中通过引用目录模板，替换当前底稿目录",
    "939": "编辑底稿索引",
    "940": "有权在底稿视图中编辑或批量编辑底稿索引",
    "941": "文档下载",
    "942": "有权在项目文档与底稿视图中下载文件/文件夹",
    "943": "历史版本下载",
    "944": "有权在项目文档与底稿视图中下载文件的历史版本",
    "945": "有权在项目文档与底稿视图中将文件/文件夹发送到会话聊天",
    "946": "有权在项目文档与底稿视图中将文件/文件夹通过外链的方式进行分享",
    "947": "文档复制",
    "948": "有权在项目文档与底稿视图中将文件或文件夹进行复制后粘贴至其它项目",
    "949": "有权在项目文档与底稿视图中将文件或文件夹保存副本到个人网盘",
    "950": "文件解锁(管理员)",
    "951": "有权在文档中解锁他人手动上锁文件以及因为网络等原因完成编辑后未能正常解除的文件锁定",
    "952": "文档设置",
    "953": "有权访问文档设置页面，根据文件格式管理文档中，在线编辑功能的使用",
    "954": "有权在文档中发起文件审批",
    "955": "新建项目",
    "956": "有权在组织下新建项目",
    "957": "项目导出",
    "958": "有权在组织下项目列表中进行列表信息导出",
    "959": "项目标签管理",
    "960": "有权新增/编辑删除项目标签数据",
    "961": "项目标签引用",
    "962": "有权在项目中关联项目标签",
    "963": "项目编码修改",
    "964": "有权在组织内项目的项目信息页面，修改项目编码，需要同时拥有项目内编辑信息权限",
    "965": "重复项目筛查",
    "966": "有权在项目列表使用重复项目筛查功能",
    "967": "提交审批",
    "968": "有权在组织下的项目里提交各类审批",
    "969": "项目回收站管理",
    "970": "有权访问项目回收站",
    "971": "项目还原",
    "972": "有权在项目回收站还原已删除的项目",
    "973": "项目终止库管理",
    "974": "有权访问项目终止库",
    "975": "借阅记录",
    "976": "有权在项目归档库中，查看归档项目的借阅记录",
    "977": "查看所有归档项目",
    "978": "有权不经过审批，在项目归档库中直接查看已归档项目",
    "979": "有权查看组织内所有项目的空间占用情况，可以对组织里所有项目的文档回收站进行清空操作",
    "980": "日程抄送人设置",
    "981": "有权在工作台的日历表中，设置日程抄送人",
    "982": "有权在工作台查看组织内的项目统计信息",
    "983": "组织管理",
    "984": "组织管理的相关权限",
    "985": "工作台的相关权限",
    "986": "后台管理",
    "987": "项目信息的相关权限",
    "988": "项目成员的相关权限",
    "989": "项目任务的相关权限",
    "990": "项目日志的相关权限",
    "991": "项目会议的相关权限",
    "992": "项目投票的相关权限",
    "993": "请输入内容",
    "994": "段落",
    "995": "标题1",
    "996": "标题2",
    "997": "标题3",
    "998": "标题4",
    "999": "标题5",
    "1000": "标题6",
    "1001": "请输入",
    "1002": "请输入任务内容",
    "1003": "请输入注意事项",
    "1004": "s 后自动关闭",
    "1005": "感谢你的反馈！",
    "1006": "你的观点对我们有着至关重要的帮助，你的反馈已被我们高度重视，同时会在接下来提升我们产品体验的过程中被使用",
    "1007": "一般般",
    "1008": "联系人",
    "1009": "普通群",
    "1010": "项目群",
    "1011": "会话",
    "1012": "单聊",
    "1013": "群聊",
    "1014": "左侧边栏导航",
    "1015": "功能栏",
    "1016": "表格列表",
    "1017": "单选右键",
    "1018": "多选右键",
    "1019": "空白区域右键",
    "1020": "列表悬浮按钮",
    "1021": "文件路径导航栏",
    "1022": "文件夹空白页按钮",
    "1023": "项目列表右键操作",
    "1024": "目录树",
    "1025": "另存为弹框",
    "1026": "组织空间",
    "1027": "回收站详情",
    "1028": "输入关键词开始搜索",
    "1029": "暂无内容",
    "1030": "您暂无权限访问，请联系系统管理员进行处理",
    "1031": "当前项目已开启独立窗口",
    "1032": "暂无项目",
    "1033": "新建你的「项目」开启智慧云文档、任务等核心功能，并邀请成员一起在线协作",
    "1034": "多选",
    "1035": "第一个节点下的全选",
    "1036": "其他节点下的全选",
    "1037": "没有用户id",
    "1038": "没有ip权限",
    "1039": "组织列表为空",
    "1040": "项目id记录为空",
    "1041": "请选择日期",
    "1042": "请输入数字",
    "1043": "在线",
    "1044": "忙碌",
    "1045": "离线",
    "1046": "重连恢复在线状态失败, 请刷新重试",
    "1047": "状态修改失败，{}",
    "1048": "[图片]",
    "1049": "文件齐备性校验",
    "1050": "使用Excel文件中的文件名称列，大批量检测目录下是否存在指定文件，检测结果将生成一个单独的控制表。检测完成后，将推送系统消息，检验文件数较多时可能需要等待一定时间",
    "1051": "批量文件快速查找、批量文件重新归档",
    "1052": "使用Excel文件中的文件名称列，以复制文件的方式，大批量提取目录下指定文件到另一个目录，提取结果将保存在一个单独的文件夹当中，并生成控制表。提取完成后，将推送系统消息，提取文件数较多时可能需要等待一定时间",
    "1053": "目录一致性校验、空文件夹批量校验",
    "1054": "选中指定文件夹，导出其下所有文件夹与文件名称，包含格式、上级目录、是否空文件夹。导出完成后，将推送系统消息，导出文件数较多时可能需要等待一定时间",
    "1055": "选择待检验目录",
    "1056": "选择目录文件",
    "1057": "选择待提取目录",
    "1058": "选择保存位置",
    "1059": "选择待导出目录",
    "1060": "获取自定义字段查询错误！",
    "1061": "忙碌中，请您留言，稍后回复",
    "1062": "您可以留言，我们看到后会在第一时间进行回复，或者您可以联系其他的客服人员，我们将竭诚为您服务！",
    "1063": "【自动回复】忙碌中，请您留言，稍后回复。",
    "1064": "【自动回复】您可以留言，我们看到后会在第一时间进行回复，或者您可以联系其他的客服人员，我们将竭诚为您服务！",
    "1065": "获取at成员信息失败，{}",
    "1066": "您好！我是{}，您有什么问题可以直接发送给我，我们会在第一时间为您解答！",
    "1067": "仅支持发送文件大小20M以内的图片",
    "1068": "{}【讨论文件合集({}项)】{}",
    "1069": "{}[图片]",
    "1070": "{}[文件]{}",
    "1071": "{}[群公告]",
    "1072": "置顶",
    "1073": "取消置顶",
    "1074": "移除会话",
    "1075": "消息免打扰",
    "1076": "允许消息通知",
    "1077": "草稿",
    "1078": "【讨论文件合集({}项)】",
    "1079": "有人@我",
    "1080": "日志消息",
    "1081": "[该消息类型本版本暂不支持查看(如需了解消息内容，请直接联系发送人)]",
    "1082": "条消息",
    "1083": "个文件",
    "1084": "条群公告",
    "1085": "该会话不存在",
    "1086": "您已离开该群聊，请联系相关人员进行添加！",
    "1087": "{}撤回了一{}",
    "1088": "请输入日志标题",
    "1089": "请输入日志内容",
    "1090": "发出人",
    "1091": "提交时间",
    "1092": "请输入日志评论内容",
    "1093": "点击选择日志评论人",
    "1094": "点击选择日志接收人",
    "1095": "搜索关联客户",
    "1096": "这个功能没什么用",
    "1097": "它分散了注意力",
    "1098": "不易理解上手难",
    "1099": "无法解决我的使用需求",
    "1100": "普通粘贴",
    "1101": "返回",
    "1102": "清空回收站",
    "1103": "您所在组织[{}]智慧云空间不足，请清理项目文档回收站或联系组织管理员进行扩容",
    "1104": "刚刚",
    "1105": "分钟前",
    "1106": "MM月DD日 HH:mm",
    "1107": "YYYY年MM月DD日 HH:mm",
    "1108": "所有人",
    "1109": "清空",
    "1110": "发送文件到",
    "1111": "拖拽编辑",
    "1112": "拖拽文件到此处进行上传",
    "1113": "当前应用不可用，请联系管理员",
    "1114": "没有匹配的小程序信息",
    "1115": "回复",
    "1116": "加急",
    "1117": "打开文件",
    "1118": "撤回",
    "1119": "该合并文件已超过600MB，请前往PC端下载",
    "1120": "历史版本V{}",
    "1121": "当前版本V{}",
    "1122": "群公告图片",
    "1123": "[有人@你]",
    "1124": "[@所有人]",
    "1125": "{}条新消息",
    "1126": "999+条新消息",
    "1127": "已超过可撤回时效",
    "1128": "已保存任务",
    "1129": "是否发消息通知执行人和抄送人?",
    "1130": "通知",
    "1131": "不用通知",
    "1132": "通知成功",
    "1133": "无法删除他人添加的执行人，请联系任务创建者操作",
    "1134": "(重复号码)",
    "1135": "请填写手机号",
    "1136": "(格式错误)",
    "1137": "删除任务",
    "1138": "关闭任务",
    "1139": "已开启拖拽排序功能",
    "1140": "已关闭拖拽排序功能",
    "1141": "确定要删除任务{}？",
    "1142": "确定要关闭任务{}",
    "1143": "确定要打开任务{}",
    "1144": "人未读",
    "1145": "全部已读",
    "1146": "正在努力加载中，请稍候…",
    "1147": "正在解锁并上传新版本，请稍候…",
    "1148": "查看成员",
    "1149": "下级",
    "1150": "创建普通群",
    "1151": "添加成员",
    "1152": "邀请成员",
    "1153": "条",
    "1154": "数据安全预警",
    "1155": "请登录CRM查看预警详情",
    "1156": "触发次数",
    "1157": "查看人员清单",
    "1158": "项目简报统计",
    "1159": "统计范围:所有项目(含可访问数据源)、按天提醒、昨天数据",
    "1160": "文件：",
    "1161": "次数：",
    "1162": "文件夹：",
    "1163": "应用时间:",
    "1164": "转发消息",
    "1165": "发送文件",
    "1166": "添加附件",
    "1167": "本地上传",
    "1168": "项目文档选择",
    "1169": "底稿选择",
    "1170": "请先选择项目后再添加附件",
    "1171": "当前审批未关联项目，因此无法选择底稿和项目文档文件",
    "1172": "当前未关联项目，因此无法选择底稿和项目文档文件",
    "1173": "请先选择所属项目",
    "1174": "选择浏览器",
    "1175": "本地浏览器",
    "1176": "扩展功能现支持Chrome浏览器、火狐浏览器、360极速模式浏览器、Safari浏览器、QQ极速模式浏览器、Microsoft Edge",
    "1177": "暂无可用浏览器",
    "1178": "现支持Chrome浏览器、火狐浏览器、360极速模式浏览器、Safari浏览器、QQ极速模式浏览器、Microsoft Edge",
    "1179": "Chrome浏览器",
    "1180": "火狐浏览器",
    "1181": "360极速模式浏览器",
    "1182": "QQ极速模式浏览器",
    "1183": "Safari浏览器",
    "1184": "开始日期",
    "1185": "结束日期",
    "1186": "版本号",
    "1187": "生成人",
    "1188": "点击查看在线编辑临时文件",
    "1189": "日期",
    "1190": "对 比",
    "1191": "文件版本",
    "1192": "还原后，当前文件「V{}」版本会保留在「文件版本」中同时会生成新的版本内容。确定要将文件还原为V{}版本内容吗？",
    "1193": "确定要还原版本内容吗？",
    "1194": "请选择两个版本进行对比",
    "1195": "文件已锁定，您不可以进行该操作",
    "1196": "还原成功",
    "1197": "归档文件不可进行此操作",
    "1198": "文件已锁定，不允许回退版本",
    "1199": "文件已锁定，不允许还原版本",
    "1200": "审批通过/审批中/修订审批中不允许还原版本",
    "1201": "回到应用中心",
    "1202": "中的搜索结果",
    "1203": "清空检索条件",
    "1204": "刷新",
    "1205": "更多目录",
    "1206": "已选中{}项",
    "1207": "请选择",
    "1208": "序号",
    "1209": "请选择项目",
    "1210": "搜索行业代码/行业分类名称",
    "1211": "搜索",
    "1212": "全选",
    "1213": "暂无数据",
    "1214": "重置",
    "1215": "重新加载",
    "1216": "正在加载中...",
    "1217": "数据获取失败，请重新加载！",
    "1218": "网络连接发生问题，请检查您的网络设置！",
    "1219": "多人在线编辑正在维护，暂不支持编辑模式切换，请双击文件使用单人本地编辑文件",
    "1220": "多人在线编辑正在维护，暂不支持编辑模式切换，请下载文件后在本地编辑文件",
    "1221": "图标",
    "1222": "多个文件",
    "1223": "多个文件夹",
    "1224": "多个",
    "1225": "个",
    "1226": "文件属性",
    "1227": "文件夹属性",
    "1228": "名称",
    "1229": "创建者",
    "1230": "包含",
    "1231": "正在计算...",
    "1232": "计算失败",
    "1233": "未选择行业分类，请先选择行业分类",
    "1234": "因多人在线编辑维护更新，编辑模式暂时不可切换，请使用单人本地编辑",
    "1235": "因多人在线编辑维护更新，编辑模式暂时不可切换，请下载文件使用本地office编辑完成后再上传文件",
    "1236": "网络异常，请检查当前设备的网络设置",
    "1237": "检测到当前账户",
    "1238": "未进行实名认证",
    "1239": "根据国家网络安全要求，账号需要“绑定手机号”实名认证后才能继续使用智慧云。可点击「实名认证」进行绑定。",
    "1240": "给您带来的不便，敬请谅解。",
    "1241": "实名认证",
    "1242": "我已认证",
    "1243": "切换组织",
    "1244": "请选择您想切换的组织",
    "1245": "加入新组织",
    "1246": "如果你的组织已在使用荣大智慧云，可通过组织ID查找加入，与成员一起沟通协作。",
    "1247": "创建新组织",
    "1248": "新组织创建后，你将成为管理员，可添加成员、管理组织架构，全面使用荣大智慧云的团队协作功能。",
    "1249": "加入或创建组织",
    "1250": "找到属于你的组织，和成员们一起协作办公",
    "1251": "安全校验未通过",
    "1252": "您好,由于您进入的{}",
    "1253": "设置了安全验证,您的IP地址未在组织要求的范围内,请尝试联系组织管理员处理或更换对应符合要求的网络后重试",
    "1254": "搜索组织名称",
    "1255": "组织不存在,无法进行操作",
    "1256": "项目编码：",
    "1257": "请选择项目编码",
    "1258": "发起人所属部门",
    "1259": "选择日期",
    "1260": "上传附件",
    "1261": "审批环节",
    "1262": "请填完必填项，会默认展示审批流程图。",
    "1263": "发起人",
    "1264": "审批人",
    "1265": "审批方式:",
    "1266": "注：审批流程涉及项目角色，需要选择项目后显示审批人。",
    "1267": "抄送方式:审批通过后通知",
    "1268": "添加抄送人",
    "1269": "注：审批流程涉及项目角色，需要选择项目后显示抄送人。",
    "1270": "是否设置提醒",
    "1271": "审批提醒",
    "1272": "接收人员",
    "1273": "提醒内容",
    "1274": "文件借阅",
    "1275": "借阅方式",
    "1276": "电子借阅",
    "1277": "纸质借阅",
    "1278": "借阅时间",
    "1279": "请选择借阅时间",
    "1280": "小时",
    "1281": "最多输入200字",
    "1282": "请选择部门",
    "1283": "审批方式",
    "1284": "抄送方式：审批通过后通知",
    "1285": "提 交",
    "1286": "底稿归档",
    "1287": "归档阶段",
    "1288": "审批环节:",
    "1289": "请输入申请内容，最多输入{}字",
    "1290": "提交",
    "1291": "IPO审核",
    "1292": "债务审核",
    "1293": "新三板审核",
    "1294": "归档表单",
    "1295": "你已经借阅当前文件",
    "1296": "底稿已被借阅",
    "1297": "请选择发起人所属部门",
    "1298": "项目归档成功后不可恢复，请谨慎操作是否确认提交归档申请？",
    "1299": "请选择您要借阅的时间",
    "1300": "请选择您要借阅的文件",
    "1301": "从借阅成功起，借阅时限为{}\"{}\"{}小时超过借阅时限后，借阅文件{}自动失效，无法查看{}是否确定借阅？",
    "1302": "确认关闭？",
    "1303": "本页面不可发起新建项目审批！",
    "1304": "无查看项目文档的权限",
    "1305": "项目所属业务类型与流程图所属业务类型不匹配",
    "1306": "提醒您尽快审批{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "1307": "提醒您尽快审批关于{}项目的{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "1308": "{}项目的",
    "1309": "提醒您尽快审批关于{}{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "1310": "接收人不能为空",
    "1311": "请填写提醒模版",
    "1312": "{}的邮箱发送失败；",
    "1313": "{}的短信发送失败；",
    "1314": "请在个人信息中完善！其余均发送成功",
    "1315": "请把表单填写完整",
    "1316": "有文件正在上传，请稍后操作",
    "1317": "请添加待审文件",
    "1318": "是否载入上次保存的草稿?",
    "1319": "确定要撤销申请吗, 是否继续?",
    "1320": "申请成功!",
    "1321": "已取消申请",
    "1322": "语言设置",
    "1323": "导航设置",
    "1324": "点击「右键」可以打开独立窗口",
    "1325": "点击进行自定义导航设置",
    "1326": "支持左右拖拽",
    "1327": "收起",
    "1328": "展开",
    "1329": "帮助",
    "1330": "隐藏应用名称",
    "1331": "已设为首页打开",
    "1332": "操作成功",
    "1333": "当前组织未填写股票代码，请前往组织信息中填写",
    "1334": "导航栏设置",
    "1335": "可以对导航栏入口进行排序和隐藏/显示设置",
    "1336": "取消首页打开",
    "1337": "创建一个组织",
    "1338": "在使用智慧云全部功能前，请先创建一个组织",
    "1339": "新组织",
    "1340": "创建",
    "1341": "新组织创建后，你将成员管理员，可添加成员、管理组织架构， 全面使用荣大智慧云的团队协作功能。",
    "1342": "加入项目",
    "1343": "当前",
    "1344": "收藏",
    "1345": "搜索项目",
    "1346": "编辑头像",
    "1347": "图片预览",
    "1348": "保存",
    "1349": "截图请大于",
    "1350": "编辑群信息",
    "1351": "群名称",
    "1352": "请输入群名称（字数限制{}字）",
    "1353": "群头像",
    "1354": "还原默认头像",
    "1355": "输入头像文字",
    "1356": "选择头像底色",
    "1357": "如果仅选择颜色，将使用该颜色的默认头像",
    "1358": "人员管理",
    "1359": "角色权限",
    "1360": "组织架构",
    "1361": "底稿管理",
    "1362": "目录管理",
    "1363": "流程引擎管理",
    "1364": "流程引擎",
    "1365": "系统配置",
    "1366": "业务类型配置",
    "1367": "任务配置",
    "1368": "业务规则配置",
    "1369": "借阅时间配置",
    "1370": "时间变量配置",
    "1371": "表单字段管理",
    "1372": "审批类型配置",
    "1373": "日志模板配置",
    "1374": "项目角色配置",
    "1375": "安全规则配置",
    "1376": "系统日志",
    "1377": "选择",
    "1378": "查询",
    "1379": "发起",
    "1380": "该流程不可用！",
    "1381": "不可发起新建项目审批！",
    "1382": "请选择项目！",
    "1383": "发起审批",
    "1384": "搜索业务类型",
    "1385": "共{}个结果,第{}个",
    "1386": "当前业务类型",
    "1387": "未搜索到结果",
    "1388": "无数据，请输入其他关键字后重试",
    "1389": "请输入想要搜索的业务类型关键字后点击搜索",
    "1390": "新增联系人",
    "1391": "姓名",
    "1392": "联系方式",
    "1393": "所属公司",
    "1394": "下一步",
    "1395": "请选择所属公司",
    "1396": "暂不支持输入特殊字符，请重新输入",
    "1397": "性别",
    "1398": "学历",
    "1399": "邮箱",
    "1400": "添加部门/职务",
    "1401": "是否公开",
    "1402": "非公开联系人仅支持在通讯录中进行查看，不支持被关联到项目",
    "1403": "是",
    "1404": "否",
    "1405": "上一步",
    "1406": "男",
    "1407": "女",
    "1408": "新增成功",
    "1409": "在「{}」下新增联系方式",
    "1410": "确定要继续添加联系方式吗？",
    "1411": "联系方式为「{}」的联系人已存在",
    "1412": "联系方式为「{}」的联系人已存在，其信息未公开，无法查看，请联系通讯录管理员",
    "1413": "创建联系人",
    "1414": "将在企业【{}】下新增联系人【{}】，是否将此联系人关联至当前项目【{}】？",
    "1415": "仅创建",
    "1416": "创建并关联至项目",
    "1417": "查询到企业「{}」下存在同名联系人，请确认其是否已存在但未维护对应联系方式",
    "1418": "如果确认要新增联系人，请点击【跳过并到下一步】继续创建",
    "1419": "在职",
    "1420": "已离职",
    "1421": "添加联系方式",
    "1422": "跳过并到下一步",
    "1423": "链接发送到我手机",
    "1424": "预警人员清单",
    "1425": "请输入人员名称",
    "1426": "选择审批类型",
    "1427": "选择类型",
    "1428": "输入关键字进行搜索",
    "1429": "已选择类型",
    "1430": "暂无选中项",
    "1431": "当前该业务类型不可选",
    "1432": "已选择",
    "1433": "关联",
    "1434": "索引列表",
    "1435": "文件索引",
    "1436": "选中文件",
    "1437": "索引路径",
    "1438": "操作人",
    "1439": "关联任务",
    "1440": "暂无对应权限",
    "1441": "请联系管理员",
    "1442": "确认引用",
    "1443": "引用后，当前目录将会清空！",
    "1444": "我已确认",
    "1445": "确认",
    "1446": "跳过",
    "1447": "选择任务模板",
    "1448": "该业务类型没有匹配的任务模板（请联系管理员为该业务类型配置任务模板）",
    "1449": "未选择任务模板，请选中对应模板后重试",
    "1450": "该业务类型没有匹配的目录",
    "1451": "（请联系管理员为该业务类型配置目录）",
    "1452": "未选择目录模板，请选中对应模板后重试",
    "1453": "确定要引用该底稿目录吗？",
    "1454": "引用后，当前目录将会被覆盖，确定要引用吗？",
    "1455": "加载失败",
    "1456": "请选择内容",
    "1457": "选择中介机构",
    "1458": "已选机构",
    "1459": "选择团队成员",
    "1460": "团队成员",
    "1461": "已选成员",
    "1462": "关联角色不能为空！",
    "1463": "选择业务类型",
    "1464": "跳 过",
    "1465": "当前项目阶段为空，不可选择",
    "1466": "清空选项",
    "1467": "请选择客户",
    "1468": "数据中心",
    "1469": "使用",
    "1470": "该类型暂不支持编辑",
    "1471": "表情",
    "1472": "自然",
    "1473": "物品",
    "1474": "地点",
    "1475": "符号",
    "1476": "当前支持核查文件的数量的最大值为{}个！",
    "1477": "单文件大小要小于等于{}M",
    "1478": "当前只支持对DOC、DOCX、XLS、XLSX、PDF（必须是可编辑版转换的）的文件进行核查！",
    "1479": "文件参数格式缺失！",
    "1480": "分享文件",
    "1481": "您可以将链接分享给您的朋友们",
    "1482": "复制链接",
    "1483": "取消外链",
    "1484": "复制成功",
    "1485": "复制失败",
    "1486": "外链取消成功",
    "1487": "外链取消失败",
    "1488": "文件分享",
    "1489": "移除",
    "1490": "重置链接",
    "1491": "通过二维码分享",
    "1492": "链接复制成功",
    "1493": "链接复制失败",
    "1494": "二维码复制成功",
    "1495": "二维码复制失败",
    "1496": "备注",
    "1497": "当前已选中",
    "1498": "新增备注",
    "1499": "请输入备注",
    "1500": "最多输入{}字",
    "1501": "请新增备注内容",
    "1502": "新增备注成功",
    "1503": "创建模板分类",
    "1504": "创 建",
    "1505": "上传到模板提示",
    "1506": "选择目录",
    "1507": "请选择目录",
    "1508": "编辑会议",
    "1509": "选择人员",
    "1510": "请输入会议主题",
    "1511": "请选择会议类型",
    "1512": "请输入会议地点",
    "1513": "起止时间",
    "1514": "会议时间",
    "1515": "会议开始时间",
    "1516": "会议结束时间",
    "1517": "提醒",
    "1518": "请输入会议内容",
    "1519": "会议开始时间不能为空",
    "1520": "会议结束时间不能为空",
    "1521": "开始时间不能小于当前时间",
    "1522": "不能同时为参会和列席人员",
    "1523": "会议主题不能为空",
    "1524": "会议地点不能为空",
    "1525": "开始时间不能大于结束时间",
    "1526": "开始时间不能等于结束时间",
    "1527": "请选择提醒方式",
    "1528": "暂无备注信息",
    "1529": "备注内容",
    "1530": "备注时间",
    "1531": "发送",
    "1532": "请输入备注内容",
    "1533": "文件关联",
    "1534": "所有人可见备注，对文件夹右键可导出核查报告（所有文件的备注）",
    "1535": "隐藏",
    "1536": "确认永久隐藏该功能吗？可在更多中勾选 \" 核查备注 \" 重新开启。",
    "1537": "确定删除备注吗？",
    "1538": "删除备注成功",
    "1539": "文件上传",
    "1540": "进度条",
    "1541": "上传速度",
    "1542": "添加文件",
    "1543": "开始上传",
    "1544": "最大允许上传{}条数据",
    "1545": "初始化中",
    "1546": "允许上传的文件类型为",
    "1547": "上传中",
    "1548": "删除成功",
    "1549": "保存新版本失败，请联系客服处理。",
    "1550": "客服电话",
    "1551": "我的客户-企业客户-客户文档",
    "1552": "我的客户-自然人客户-客户文档",
    "1553": "我的客户-中介机构-客户文档",
    "1554": "投票决策",
    "1555": "投票意见",
    "1556": "请输入投票意见",
    "1557": "同意",
    "1558": "确定要执行投票吗？",
    "1559": "投票决策仅可执行一次，确定要继续操作吗？",
    "1560": "已取消投票",
    "1561": "投票意见不能为空",
    "1562": "请选择投票类型",
    "1563": "选择开始日期时间",
    "1564": "选择结束日期时间",
    "1565": "该投票需要角色",
    "1566": "不少于",
    "1567": "投票名称不能为空",
    "1568": "投票类型不能为空",
    "1569": "投票人不能为空",
    "1570": "请选择开始时间",
    "1571": "请选择结束时间",
    "1572": "结束时间需大于当前时间1小时",
    "1573": "投票名称内容不能为空",
    "1574": "投票结果",
    "1575": "项目简称",
    "1576": "所属部门:",
    "1577": "项目描述",
    "1578": "相关会议",
    "1579": "表决结果",
    "1580": "（已选中",
    "1581": "项，共",
    "1582": "项）",
    "1583": "该文件已删除",
    "1584": "加载中",
    "1585": "】邀请您加入【",
    "1586": "】项目",
    "1587": "所属组织",
    "1588": "忽略",
    "1589": "项目文件",
    "1590": "联系人{}群组",
    "1591": "选择对象",
    "1592": "esc退出搜索",
    "1593": "交接详情",
    "1594": "指派交接",
    "1595": "交接人 【",
    "1596": "暂不处理",
    "1597": "指派选中项",
    "1598": "请选择移交人",
    "1599": "你是否满意本次版本(v1.6.0)更新？",
    "1600": "需要再用用",
    "1601": "有进步",
    "1602": "很赞",
    "1603": "产品经理：范恺",
    "1604": "产品建议、吐槽、唠嗑、养猫...",
    "1605": "欢迎扫描左侧二维码",
    "1606": "交个朋友",
    "1607": "这里是标题",
    "1608": "高级检索",
    "1609": "未填写",
    "1610": "高级筛选",
    "1611": "清空筛选条件",
    "1612": "暂未查询到与",
    "1613": "相符的内容或信息",
    "1614": "暂未查询到与之相符的内容或信息",
    "1615": "包含高级检索条件",
    "1616": "请检查输入的关键词是否有误",
    "1617": "或",
    "1618": "点击此处",
    "1619": "使用全文检索查找相关内容",
    "1620": "已锁定、有索引的、有备注的、有审批记录的、无索引的、待审批、审批中、节点审批通过、审批通过、驳回未修改、驳回已修改、修订中、修订审批中、有设置提醒的、已归档",
    "1621": "无文件、有文件",
    "1622": "{} 至 {}",
    "1623": "最小化",
    "1624": "最大化",
    "1625": "可正常发消息的群数量/可使用的群上限",
    "1626": "可正常发消息的群组(",
    "1627": "暂无群组",
    "1628": "查看已选列表",
    "1629": "当前已选数量",
    "1630": "替换",
    "1631": "不可发消息的群数量",
    "1632": "可替换群组(",
    "1633": "暂无可替换群组",
    "1634": "当前可选数量",
    "1635": "当前无选中的群组",
    "1636": "置换成功",
    "1637": "置换失败",
    "1638": "返回前台",
    "1639": "切换语言",
    "1640": "偏好设置",
    "1641": "版本说明",
    "1642": "使用帮助",
    "1643": "下载手机版",
    "1644": "信披搜索、数据中心一键直达",
    "1645": "二郎神",
    "1646": "咨询服务",
    "1647": "有新版本可更新",
    "1648": "文件处理列表",
    "1649": "下载客户端",
    "1650": "手机端下载",
    "1651": "有更新可用，刷新即可",
    "1652": "传输列表",
    "1653": "搜索（{}）",
    "1654": "检测到新的版本更新，点击「立即更新」后进行体验",
    "1655": "版本更新",
    "1656": "立即更新",
    "1657": "使用帮助手册",
    "1658": "确认退出登录吗",
    "1659": "退出失败!",
    "1660": "传输列表中，有文件进度卡在0或100不继续进行，初步判断是由于域名解析失败导致的，建议使用DNS优先进行解决。",
    "1661": "后续出现此问题不再提示",
    "1662": "前去启用",
    "1663": "稍后可在系统设置中启用DNS优选功能。",
    "1664": "若您使用DNS优选功能后，仍多次捕获到域名无法解析，您可以联系售后询问，售后电话：",
    "1665": "清除选中记录",
    "1666": "全部取消",
    "1667": "待处理文件",
    "1668": "注：请您核对上传失败版本与当前版本内容，如要上传新版本",
    "1669": "请备份后手动上传",
    "1670": "，点击定位可跳转到文件所在位置。",
    "1671": "组织名称",
    "1672": "版本进行",
    "1673": "手动解锁",
    "1674": "备份",
    "1675": "粘贴文件",
    "1676": "暂无任务",
    "1677": "文件数量",
    "1678": "进度",
    "1679": "锁定文件",
    "1680": "展示最近一次进行批量解锁时，所选文件范围内的锁定文件",
    "1681": "文件处理",
    "1682": "粘贴任务正在进行，确定要取消操作吗？",
    "1683": "成功",
    "1684": "正在准备复制",
    "1685": "正在复制",
    "1686": "暂不支持跳转客户文档",
    "1687": "清除记录成功",
    "1688": "hover 激活",
    "1689": "呕心沥血难保错误少 智能核查荣大新法宝",
    "1690": "分享的图片",
    "1691": "当前图片序号：",
    "1692": "该图片已被撤回",
    "1693": "实际大小",
    "1694": "缩小",
    "1695": "旋转",
    "1696": "{}分享的图片",
    "1697": "复制成功！",
    "1698": "复制失败，请联系管理员进行反馈！",
    "1699": "链接邀请成员",
    "1700": "组织链接",
    "1701": "分享链接，快速邀请成员加入组织。",
    "1702": "失效时间",
    "1703": "复制链接邀请",
    "1704": "“{}”邀请您加入“{}”,点击链接立即申请加入吧！用荣大智慧云开启高效协作模式。",
    "1705": "邀请链接复制成功",
    "1706": "邀请链接复制失败",
    "1707": "邀请组织成员一起协作",
    "1708": "当前组织可用人数",
    "1709": "人",
    "1710": "可再邀请",
    "1711": "增加可用人数",
    "1712": "邀请组织成员",
    "1713": "邀请其他组织成员",
    "1714": "链接邀请",
    "1715": "邀请成功",
    "1716": "请输入成员手机号或邮箱",
    "1717": "继续添加",
    "1718": "发送邀请",
    "1719": "手机号/邮箱格式错误",
    "1720": "已邀请加入组织",
    "1721": "加入组织",
    "1722": "通过组织ID查找加入。暂无组织，点击",
    "1723": "创建组织",
    "1724": "组织ID",
    "1725": "请输入组织ID",
    "1726": "加入",
    "1727": "已提交申请",
    "1728": "请耐心等待管理员审核",
    "1729": "组织类型",
    "1730": "请输入{}ID",
    "1731": "搜索内容为空",
    "1732": "申请加入",
    "1733": "组织",
    "1734": "您可以联系组织管理者索取组织ID，申请加入对应的组织。也可以由组织成员通过您的验证邮箱或手机号邀请您加入组织。",
    "1735": "您可以联系项目负责人索取项目ID，申请加入对应的项目。也可以由项目负责人邀请您加入项目。",
    "1736": "申请加入产研项目组，项目编码:{}",
    "1737": "加入申请已发送",
    "1738": "申请加入成功",
    "1739": "拼命加载中",
    "1740": "已选",
    "1741": "邀请你加入「",
    "1742": "即刻加入",
    "1743": "协作邀请",
    "1744": "加入团队一起高效协作办公，告别繁琐和沉重的重复工作",
    "1745": "链接不存在",
    "1746": "邀请链接不存在或已失效，请联系项目管理员重新发起邀请",
    "1747": "项目加入成功",
    "1748": "链接已失效，请联系邀请人重新发送邀请",
    "1749": "消息加急提醒",
    "1750": "1、群聊内发送含@人员的消息可加急提醒单聊消息均支持加急提醒",
    "1751": "2、提醒方式可选",
    "1752": "“仅应用内”",
    "1753": "“应用内+短信”",
    "1754": "的方式。",
    "1755": "由于部分文件编码格式特殊，如遇到不能正常播放时,请下载查看",
    "1756": "您的浏览器不支持video播放",
    "1757": "该{}已被撤回",
    "1758": "暂不提示",
    "1759": "永不提示",
    "1760": "在线服务",
    "1761": "群聊的备注名称仅自己可见",
    "1762": "组织的备注名称仅自己可见",
    "1763": "操作时间",
    "1764": "操作人员",
    "1765": "账号验证",
    "1766": "当前用户",
    "1767": "登录密码",
    "1768": "请输入密码",
    "1769": "选择移交人员",
    "1770": "点击选择移交人员",
    "1771": "移交组织",
    "1772": "删除组织",
    "1773": "请选择移交人员",
    "1774": "密码不能为空",
    "1775": "最多输入50字",
    "1776": "请选择组织类型",
    "1777": "股票代码",
    "1778": "请输入股票代码(最多输入6个数字)",
    "1779": "组织简介",
    "1780": "请输入组织简介(最多输入200字)",
    "1781": "使用官方提供的初始化数据模板",
    "1782": "注：数据包含系统角色及权限、项目角色及权限、底稿目录、业务类型（含项目阶段）、任务模板、时间变量",
    "1783": "组织名称不能为空",
    "1784": "组织类型不能为空",
    "1785": "请填写正确的股票代码",
    "1786": "组织简介的字数限制为200字",
    "1787": "修改股票代码后，已经上传的股东名册数据不可见，请慎重修改!",
    "1788": "修改成功",
    "1789": "组织创建成功",
    "1790": "现在，从新建一个项目开始全面使用智慧云吧跟着引导，轻松几步就搞定",
    "1791": "稍后新建",
    "1792": "开始体验前，请先创建一个组织吧",
    "1793": "您的角色（选填）",
    "1794": "请输入(选填)",
    "1795": "暂不创建",
    "1796": "建立一个敏捷项目组，开启文档、任务等核心功能",
    "1797": "暂不",
    "1798": "请选择业务类型",
    "1799": "新建项目已提交审批！",
    "1800": "项目创建成功",
    "1801": "恭喜你已成功开启文档、任务等智慧云的核心功能，现在开始体验吧",
    "1802": "立即体验",
    "1803": "系统消息图",
    "1804": "推广活动图",
    "1805": "支持格式{}，请上传正确格式图片",
    "1806": "删除组织后：",
    "1807": "组织内所有内容（项目、文档、部门、成员等）都将永久删除，此操作不可逆，请谨慎操作",
    "1808": "当前组织已经购买的人员和空间将同步失效",
    "1809": "可用人数",
    "1810": "可用空间",
    "1811": "到期时间",
    "1812": "确定删除",
    "1813": "试用版永久免费！使用更多人员和空间，请购买正式版！",
    "1814": "{}/{}人",
    "1815": "智慧云已用空间",
    "1816": "已超总空间限制",
    "1817": "项目已用空间(包含回收站)",
    "1818": "客户文档已用空间",
    "1819": "剩余空间",
    "1820": "项目已用空间",
    "1821": "搜索项目ID/项目名称",
    "1822": "正在清空回收站，请稍候；本次计算完成后才能进行下一次清空！",
    "1823": "正在清空",
    "1824": "排名",
    "1825": "已用总空间",
    "1826": "文档已用空间",
    "1827": "文档回收站已用空间",
    "1828": "购买",
    "1829": "获取数据失败，请稍后重试",
    "1830": "空间比例计算失败，请联系管理员",
    "1831": "你确定要清空所有项目的文档回收站吗？清空后文件将无法恢复",
    "1832": "操作失败，请稍后重试",
    "1833": "获取权限失败，请稍后重试",
    "1834": "项目文档-回收站",
    "1835": "组织信息",
    "1836": "没有找到相关结果",
    "1837": "备注名（仅个人可见）",
    "1838": "暂无",
    "1839": "付费信息",
    "1840": "试用版",
    "1841": "正式版",
    "1842": "试用版永久免费！如需添加更多人员和使用空间，请购买正式版。",
    "1843": "立即购买",
    "1844": "续费",
    "1845": "成员数量",
    "1846": "扩容",
    "1847": "成员数量已超限制，请扩容",
    "1848": "系统空间",
    "1849": "系统空间已超限制，请扩容",
    "1850": "更多内容",
    "1851": "归属者",
    "1852": "退出组织",
    "1853": "删除组织后，组织内所有项目、部门、成员、文档等内容将永久删除且不可恢复，请谨慎操作",
    "1854": "一旦你退出了组织，将无法再看到该组织内的所有信息及文档，请谨慎对待",
    "1855": "确定移交组织吗？",
    "1856": "移交组织后你将不再是该组织的所属者, 仅保留管理员权限, 确定要继续移交组织吗?",
    "1857": "交接工作",
    "1858": "退出组织后，你在该组织下的所有项目将会转交给对方，由你上锁的文件将会自动解锁",
    "1859": "选择交接人员",
    "1860": "点击选择交接人员",
    "1861": "交接人不能为空",
    "1862": "退出成功",
    "1863": "已发送通知给用户",
    "1864": ", 请提醒对方查收",
    "1865": "确定退出",
    "1866": "交接人不能选本人",
    "1867": "移交后你将不再是该组织的所属者，但保留管理员权限，是否继续移交？",
    "1868": "移 交",
    "1869": "移交成功",
    "1870": "文件目录",
    "1871": "操作对象",
    "1872": "通过文档下载文件/文件夹",
    "1873": "点击外链分享",
    "1874": "通过外链分享下载文件/文件夹",
    "1875": "删除文件/文件夹",
    "1876": "修改文件",
    "1877": "新增文件/文件夹",
    "1878": "推送设置",
    "1879": "是否推送文件统计",
    "1880": "推送",
    "1881": "不推送",
    "1882": "在全部组织中不进行推送",
    "1883": "勾选后您将不接收所有组织的项目简报统计信息",
    "1884": "每天{}推送昨日文件相关数据",
    "1885": "上午10:00",
    "1886": "文件编辑模式设置",
    "1887": "选择开启以下文件类型，所有成员可对不同类型格式的文件进行多人在线编辑",
    "1888": "Word 类文件",
    "1889": "多人编辑开启后将使用WPS编辑器进行文件编辑，可能会与通过MS office编辑器进行编辑的文件产生兼容影响，请知悉！",
    "1890": "开启后，可对该类型文件进行多人在线编辑(文件格式包含：doc | docx | dot | dotx | wps | wpt | docm)",
    "1891": "Excel 类文件",
    "1892": "开启后，可对该类型文件进行多人在线编辑(文件格式包含：xls | xlsx | xlsm | xlt | xltx |et)",
    "1893": "PPT 类文件",
    "1894": "开启后，可对该类型文件进行多人在线编辑(文件格式包含：ppt | pptx | pptm | pps | ppsx |ppsm | potx | dpt | dps)",
    "1895": "PDF 类文件",
    "1896": "开启后，可对该类型文件进行多人在线编辑",
    "1897": "多人编辑开启后将使用WPS编辑器进行文件编辑，可能会与通过MS office编辑器进行编辑的文件产生兼容影响。如果编辑文件时对格式要求比较敏感，为了减少因兼容问题导致格式错乱的风险，建议保持使用本地编辑模式；确定继续开启多人编辑模式吗？",
    "1898": "确定开启「多人编辑」模式吗？",
    "1899": "自定义功能栏",
    "1900": "请输入任务文件夹名称",
    "1901": "完成",
    "1902": "完成并转发",
    "1903": "分享任务",
    "1904": "分享成功",
    "1905": "请填写完整",
    "1906": "请选择标签名称",
    "1907": "无标签",
    "1908": "项目名备注（仅自己可见）",
    "1909": "请输入备注名称（最多20字）",
    "1910": "取 消",
    "1911": "确 定",
    "1912": "请选择文件",
    "1913": "该文件正在审批中，不能选择",
    "1914": "锁定中的文件不能再次发起审批，请重新选择",
    "1915": "请输入文件夹名称",
    "1916": "未检索到相关内容",
    "1917": "请选择要保存的路径",
    "1918": "操作失败，图片大小不超过20M",
    "1919": "富文本编辑器图片上传",
    "1920": "启用",
    "1921": "禁用",
    "1922": "新建空白日志",
    "1923": "复用已有日志",
    "1924": "模板已启用",
    "1925": "模板已禁用",
    "1926": "你确定要删除该日志模板吗?",
    "1927": "该文件格式不支持在线编辑",
    "1928": "多人在线",
    "1929": "单人本地",
    "1930": "取消关联",
    "1931": "共{}项",
    "1932": "请输入昵称",
    "1933": "正在解锁并保存文件",
    "1934": "该文件夹已被删除，即将返回首层文件夹",
    "1935": "继续提交",
    "1936": "残忍离开",
    "1937": "不支持该类型文件上传，请重新选择",
    "1938": "支持格式{}，请上传正确格式头像",
    "1939": "头像大小不能超过10MB",
    "1940": "检测到本次上传有{}个重名对象 (文件夹/文件)",
    "1941": "更新版本",
    "1942": "为本次所有重名对象执行此操作",
    "1943": "文件重名",
    "1944": "文件上传 (",
    "1945": "重试",
    "1946": "找不到文件路径",
    "1947": "等待上传",
    "1948": "正在上传",
    "1949": "上传新版本每次只能上传一个文件",
    "1950": "无更新版本权限",
    "1951": "该文件夹下无文件，请重新选择",
    "1952": "无后缀名文件",
    "1953": "文件名称不能为空",
    "1954": "该文件超出100G限制",
    "1955": "普通文件",
    "1956": "荣大XB",
    "1957": "北交所XB",
    "1958": "文件上传成功",
    "1959": "文件上传失败，请检查网络，或选择重新上传",
    "1960": "部分文件上传失败，请检查网络，或选择重新上传",
    "1961": "当前项目进行阶段",
    "1962": "文件保存路径",
    "1963": "选择上传阶段",
    "1964": "选择粘贴阶段",
    "1965": "上传阶段",
    "1966": "粘贴阶段",
    "1967": "项目文档 / {} / 底稿上传",
    "1968": "上传文件到「",
    "1969": "上传文件到当前目录下",
    "1970": "客户文档暂不支持文件夹上传，将自动过滤",
    "1971": "搜索结果页不允许上传",
    "1972": "左侧暂无目录，无法进行上传操作",
    "1973": "很抱歉，您访问的浏览器无法使用“文件夹上传”功能！",
    "1974": "1、为了获得更好的使用体验，您可以下载最新版本的",
    "1975": "并设置成默认浏览器",
    "1976": "2、您也可以下载使用最新的荣大智慧云客户端",
    "1977": "条)",
    "1978": "标准化",
    "1979": "预 览",
    "1980": "只 读",
    "1981": "下 载",
    "1982": "当文件编辑后“",
    "1983": "大小超过20MB将无法保存成功",
    "1984": "”，建议",
    "1985": "以上的文件通过“",
    "1986": "”方式进行编辑；",
    "1987": "当文件通过“",
    "1988": "”方式时，需要注意“",
    "1989": "编辑后的",
    "1990": "文件大小不超过20MB”。",
    "1991": "注：上述问题正在努力解决中，请耐心等待…",
    "1992": "关 闭",
    "1993": "个,",
    "1994": "已驳回",
    "1995": "审批意见",
    "1996": "暂无审批意见",
    "1997": "【版本:",
    "1998": "取消回复",
    "1999": "发布",
    "2000": "条回复",
    "2001": "请输入{}审批意见，最多输入1000字",
    "2002": "审批结果",
    "2003": "通过",
    "2004": "消息通知",
    "2005": "通过站内信通知发起人查看",
    "2006": "审批回复详情",
    "2007": "共有",
    "2008": "请输入意见内容",
    "2009": "请勾选审批结果",
    "2010": "审批记录",
    "2011": "提交人",
    "2012": "审批状态",
    "2013": "未审批",
    "2014": "提审",
    "2015": "查看审批",
    "2016": "列表",
    "2017": "审批附件",
    "2018": "审批信息",
    "2019": "级审批:",
    "2020": "审批时间",
    "2021": "转交时间",
    "2022": "转交理由",
    "2023": "我的审批-我发起的-审批记录-查看-{}审批-{}审批意见页",
    "2024": "请选择要下载的数据",
    "2025": "{}-审批附件.zip",
    "2026": "批量编辑角色",
    "2027": "输入关键字搜索",
    "2028": "取消关联审批",
    "2029": "此审批流程要求您要有关联的审批",
    "2030": "提交人员",
    "2031": "是否取消该关联",
    "2032": "勾选后以下人员必须将日程抄送给我",
    "2033": "输入关键字进行过滤",
    "2034": "已选人员",
    "2035": "注：全选后新加入部门的人员自动抄送",
    "2036": "请输入人员",
    "2037": "暂未选择人员",
    "2038": "修改日程",
    "2039": "请输入日程名称",
    "2040": "请选择人员",
    "2041": "全天",
    "2042": "默认通过站内信通知发送给对方，点击x删除",
    "2043": "日程名称内容不能为空",
    "2044": "所属项目不能为空",
    "2045": "人员不能为空",
    "2046": "开始日期不能为空",
    "2047": "结束日期不能为空",
    "2048": "结束日期不能大于开始日期",
    "2049": "日期重复方式不能为空",
    "2050": "日程内容不能为空",
    "2051": "机构联系人",
    "2052": "系统角色",
    "2053": "默认的人员不能删除",
    "2054": "默认抄送人员不能删除",
    "2055": "可选人员",
    "2056": "请输入角色",
    "2057": "手机号",
    "2058": "职位",
    "2059": "编辑标签",
    "2060": "标签",
    "2061": "最多还能添加{}个",
    "2062": "按enter键进行分割",
    "2063": "最近使用的标签",
    "2064": "标签名不能相同",
    "2065": "标签最多添加10个",
    "2066": "标签名不能为空",
    "2067": "我的日程",
    "2068": "编 辑",
    "2069": "删 除",
    "2070": "新建日志",
    "2071": "请选择所属项目",
    "2072": "日志类型",
    "2073": "请选择日志类型",
    "2074": "确 认",
    "2075": "日报",
    "2076": "周报",
    "2077": "月报",
    "2078": "日志类型不能为空",
    "2079": "审批流程预览",
    "2080": "暂无附件",
    "2081": "上一步执行人",
    "2082": "指定用户",
    "2083": "指定角色",
    "2084": "前台",
    "2085": "后台",
    "2086": "部门主管",
    "2087": "发起人的",
    "2088": "级主管",
    "2089": "暂未选择审批人",
    "2090": "暂未匹配到对应的审批人",
    "2091": "暂未配置流程图",
    "2092": "已选目录",
    "2093": "请输入关键字（以空格区分）",
    "2094": "暂无相关聊天记录",
    "2095": "点击可定位到对应聊天记录",
    "2096": "昨天{}",
    "2097": "选择角色",
    "2098": "待选角色",
    "2099": "已选角色",
    "2100": "时间选择",
    "2101": "请输入操作人",
    "2102": "操作类型",
    "2103": "请选择操作类型",
    "2104": "事件",
    "2105": "导出",
    "2106": "增加目录",
    "2107": "删除目录",
    "2108": "重命名目录",
    "2109": "下载文件",
    "2110": "解锁文件",
    "2111": "重命名文件",
    "2112": "删除文件",
    "2113": "预览文件",
    "2114": "更新文件版本",
    "2115": "版本还原",
    "2116": "下载全局查看文件",
    "2117": "导出全局查看记录",
    "2118": "增加文件批注",
    "2119": "添加标签",
    "2120": "取消标签",
    "2121": "添加索引",
    "2122": "取消索引",
    "2123": "设为底稿",
    "2124": "增加目录批注",
    "2125": "关联审批",
    "2126": "关联审批（当前审批已关联审批）",
    "2127": "请选择状态",
    "2128": "提交人：",
    "2129": "请选择提交人",
    "2130": "待我审批",
    "2131": "我已审批",
    "2132": "全部（",
    "2133": "审批完成（",
    "2134": "审批中（",
    "2135": "当前审批人",
    "2136": "我发起的",
    "2137": "已撤销（",
    "2138": "抄送我的",
    "2139": "暂未选择角色",
    "2140": "待选类型",
    "2141": "已选类型",
    "2142": "暂未选择类型",
    "2143": "请输入关键字",
    "2144": "| 前台",
    "2145": "| 前台",
    "2146": "| 后台",
    "2147": "| 后台",
    "2148": "投票记录",
    "2149": "投票时间:",
    "2150": "未投票",
    "2151": "投票附件",
    "2152": "该附件被删除",
    "2153": "{}- 投票附件.zip",
    "2154": "我们正在全力搜索中，请点击",
    "2155": "刷新试试",
    "2156": "正在登录中......",
    "2157": "客户端下载",
    "2158": "关于我们",
    "2159": "高效",
    "2160": "专业",
    "2161": "协作",
    "2162": "管理",
    "2163": "登录",
    "2164": "北京荣大科技股份有限公司",
    "2165": "服务热线",
    "2166": "暂不支持IE浏览器10以下版本！请更新您的浏览器版本",
    "2167": "您已成功加入群聊",
    "2168": "新建第一个项目",
    "2169": "跟着引导，轻松几步搞定，开启智慧云文档、任务等核心功能，并邀请成员一起在线协作",
    "2170": "立即开始",
    "2171": "欢迎来到智慧云",
    "2172": "为了让智慧云能够更大限度的帮助你，在开始前，请帮助我们了解你",
    "2173": "选择你的机构属性",
    "2174": "进入项目",
    "2175": "查看新用户引导",
    "2176": "快速开始",
    "2177": "我们准备了「{}」常用的核心功能引导帮助你快速理解和使用智慧云！",
    "2178": "我要自行探索",
    "2179": "开始体验",
    "2180": "返回上一步",
    "2181": "数据列表",
    "2182": "请搜索版本号",
    "2183": "刷新列表",
    "2184": "新增数据",
    "2185": "链接地址",
    "2186": "说明",
    "2187": "暂无收藏项目",
    "2188": "删除后，会在联系人已关联的项目中同步进行移除",
    "2189": "公司信息",
    "2190": "离职",
    "2191": "职务：",
    "2192": "从业履历",
    "2193": "起始日期",
    "2194": "截止日期",
    "2195": "更新时间",
    "2196": "研究生",
    "2197": "请填写部门和职务",
    "2198": "编辑成功",
    "2199": "联系人详情",
    "2200": "基本信息",
    "2201": "项目经历",
    "2202": "确定要关闭页面吗？",
    "2203": "当前处于编辑状态，当前操作将不保存修改内容，确定要继续操作吗？",
    "2204": "确认要离开此页面吗？",
    "2205": "客户学历",
    "2206": "（非公开联系人仅支持在通讯录中进行查看，不支持被关联到项目）",
    "2207": "融资类型",
    "2208": "交易板块",
    "2209": "交易场所",
    "2210": "上市（挂牌）日期",
    "2211": "项目角色",
    "2212": "联系人姓名",
    "2213": "全部拒绝",
    "2214": "终止授权",
    "2215": "已授权",
    "2216": "未授权",
    "2217": "联系方式授权",
    "2218": "联系方式终止授权",
    "2219": "授权",
    "2220": "授权（{}）",
    "2221": "申请人",
    "2222": "应用项目",
    "2223": "待确认",
    "2224": "申请时间",
    "2225": "最后更新时间",
    "2226": "共",
    "2227": "客户信息",
    "2228": "统一社会信用代码",
    "2229": "企业类型",
    "2230": "法定代表人",
    "2231": "注册资本",
    "2232": "成立日期",
    "2233": "主营业务",
    "2234": "客户信息（选填）",
    "2235": "企业名称",
    "2236": "请选择企业",
    "2237": "法人代表",
    "2238": "此客户已关联，请勿重复操作！",
    "2239": "中介机构（选填）",
    "2240": "添加关联",
    "2241": "新增客户",
    "2242": "自动回显",
    "2243": "经营状态",
    "2244": "代表人职务",
    "2245": "企业地址",
    "2246": "企业标签",
    "2247": "请选择企业名称",
    "2248": "请选择客户类型",
    "2249": "当前已有内容，关闭将不予保存，确定要继续操作吗？",
    "2250": "选择企业",
    "2251": "仅支持输入中文关键词搜索",
    "2252": "与“{}”相匹配的企业",
    "2253": "没有找到相匹配的企业",
    "2254": "请输入正确的企业名称",
    "2255": "查询失败，请联系管理员",
    "2256": "企业已存在",
    "2257": "股份公司",
    "2258": "有限公司",
    "2259": "集团有限公司",
    "2260": "集团股份有限公司",
    "2261": "股份",
    "2262": "有限",
    "2263": "集团",
    "2264": "公司",
    "2265": "企业",
    "2266": "厂",
    "2267": "店",
    "2268": "馆",
    "2269": "部",
    "2270": "行",
    "2271": "中心",
    "2272": "中国",
    "2273": "中华",
    "2274": "国家",
    "2275": "更新企业信息",
    "2276": "当前客户",
    "2277": "未关联至任意组织内项目，确认要继续删除吗？",
    "2278": "客户",
    "2279": "删除后",
    "2280": "将自动从项目中移除客户信息",
    "2281": "当前客户已关联",
    "2282": "可在「项目列表」中筛选查看详情，确定要继续删除吗？",
    "2283": "确定要删除该客户吗？",
    "2284": "更新失败",
    "2285": "更新成功",
    "2286": "确定要将该人员设为离职吗？",
    "2287": "联系人「",
    "2288": "」将在企业「",
    "2289": "」下变为离职状态，确定要继续此操作吗？",
    "2290": "请维护联系人在此企业的就职时间（选填）",
    "2291": "不保留用户离职信息",
    "2292": "仅用于用户公司信息维护错误时进行修正使用",
    "2293": "确定离职",
    "2294": "确定移除",
    "2295": "客户详情",
    "2296": "联系人信息",
    "2297": "发行人",
    "2298": "保荐机构",
    "2299": "评估机构",
    "2300": "项目详情",
    "2301": "上市/发行日期",
    "2302": "联系表信息",
    "2303": "搜索行业代码/名称",
    "2304": "关联中介机构",
    "2305": "添加中介机构",
    "2306": "请选择机构",
    "2307": "请选择客户后点击确定",
    "2308": "该机构已被关联至此项目，请勿重复操作",
    "2309": "添加成功",
    "2310": "移除中介机构",
    "2311": "移除项目所关联的中介机构后，其下已被关联至此项目的联系人将会同步取消关联，确定要继续移除吗？",
    "2312": "移除成功",
    "2313": "关联通讯录联系人",
    "2314": "搜索联系人姓名",
    "2315": "关联联系人",
    "2316": "请输入联系人姓名后搜索",
    "2317": "联系人已被关联，请勿重复添加",
    "2318": "请输入联系人姓名后查询",
    "2319": "关联成功",
    "2320": "变更关联客户",
    "2321": "项目联系人",
    "2322": "查看联系人",
    "2323": "请选择客户后查看联系人",
    "2324": "确定变更关联客户吗？",
    "2325": "变更客户后，项目内成员将无法继续查看当前客户信息，确定要继续变更关联客户吗？",
    "2326": "关联机构",
    "2327": "已关联",
    "2328": "申请查看联系方式",
    "2329": "已申请查看",
    "2330": "操作助手",
    "2331": "按照以下步骤和我一起完成智慧云核心功能的操作使用吧",
    "2332": "遇到问题需要帮助？",
    "2333": "产品使用中遇到疑问，你可以向我们的产品专家在线进行询问",
    "2334": "在线咨询",
    "2335": "如何上传/新建文件？",
    "2336": "上传/新建文件",
    "2337": "「拖拽文件」到项目文档区域 或 点击「上传」按钮进行本地文件的上传，或 点击「新建」按钮进行文件新建的操作。",
    "2338": "如何对文件发起讨论？",
    "2339": "对文件发起讨论",
    "2340": "选中要发起讨论的文件，点击「发送到聊天」跳转至会话对象聊天窗口，可对发起讨论的文件进行文字说明，点击发送按钮即可。",
    "2341": "如何分享文件？",
    "2342": "选中要分享的文件，点击「外链分享」通过分享文档链接或二维码至相关人员进行查看文档内容。",
    "2343": "如何邀请项目成员？",
    "2344": "邀请项目成员",
    "2345": "点击右侧工具栏",
    "2346": "可快速邀请项目成员，邀请方式有三种：可通过1、链接邀请，2、手机号邀请，3、按群组邀请。",
    "2347": "新增「全局检索」功能",
    "2348": "新增对文件、联系人/群组、聊天记录的全局检索功能，点击全局检索入口或",
    "2349": "快速唤起全局检索弹框，可以对任意组织、任意项目中的文件、联系人进行检索",
    "2350": "关闭当前页",
    "2351": "关闭所有内容(共{}条)",
    "2352": "新功能上线",
    "2353": "新应用上架",
    "2354": "活动开始啦",
    "2355": "单独删除",
    "2356": "全部删除",
    "2357": "新增「项目文档窗体独立」功能",
    "2358": "将不同组织中不同项目的文档页面作为独立窗口打开，可以更快捷的实现跨组织/项目编辑和查看文件，你可以自由设置想要打开的项目文档，让文件编辑更加便捷、高效",
    "2359": "新增「文件收藏」功能",
    "2360": "你可以将近期经常使用或阶段性工作的文件添加到收藏，通过已收藏的文件快速找到项目文件并开始工作，提高在众多文件夹中查找目标文件的效率",
    "2361": "请选择中介机构名称",
    "2362": "点击选择业务类型",
    "2363": "字段获取错误，{}",
    "2364": "有时间",
    "2365": "无时间",
    "2366": "点击选择部门",
    "2367": "包含任一",
    "2368": "包含全部",
    "2369": "点击选择审批类型",
    "2370": "点击选择人员",
    "2371": "创建网查任务",
    "2372": "输入关键词搜索",
    "2373": "筛选",
    "2374": "链接",
    "2375": "添加筛选条件",
    "2376": "发送人",
    "2377": "@消息:",
    "2378": "请输入检索条件",
    "2379": "你可能想找",
    "2380": "最近联系过",
    "2381": "点击查看更多",
    "2382": "已展示全部结果",
    "2383": "没有找到关于",
    "2384": "群组",
    "2385": "群聊名称",
    "2386": "最近搜索",
    "2387": "选择{}",
    "2388": "未检索到数据",
    "2389": "标题",
    "2390": "匹配全部关键字 空格区分",
    "2391": "匹配任一关键词 空格区分",
    "2392": "不匹配关键词 空格区分",
    "2393": "结果展示顺序",
    "2394": "按时间排序",
    "2395": "按匹配度排序",
    "2396": "内容：",
    "2397": "匹配全部关键词 空格区分",
    "2398": "文档范围",
    "2399": "点击选择",
    "2400": "文件大小",
    "2401": "大小输入有误，请调整",
    "2402": "本次检索结果",
    "2403": "全部展开",
    "2404": "全部收起",
    "2405": "请先加入组织后，进行文件检索",
    "2406": "请输入检索条件后查询",
    "2407": "反馈",
    "2408": "网查工具使用体验调研",
    "2409": "感谢使用「智能网查」应用，为了进一步提升你的使用体验，请花2-3分钟时间反馈一下你使用「智能网查」的体验，产品后续怎么优化，想听听你的建议",
    "2410": "我要评论",
    "2411": "我要提建议",
    "2412": "我有产品需求",
    "2413": "请选择要评论的任务",
    "2414": "请评价你对本次任务执行的满意度",
    "2415": "1、网站满足需求程度",
    "2416": "2、查询结果满意程度",
    "2417": "3、查询结果精确程度",
    "2418": "4、查询速度满意程度",
    "2419": "5、操作易用性的满意程度",
    "2420": "你愿意推荐他人使用「智能网查」应用吗？",
    "2421": "其他问题评论",
    "2422": "还有其他问题要评论？请在这里输入",
    "2423": "上传图片附件",
    "2424": "图片支持jpg、png格式，最大不超过 5 M",
    "2425": "请选择问题分类",
    "2426": "问题描述",
    "2427": "需求标题",
    "2428": "请概述一下你的需求",
    "2429": "请描述一下该需求的业务场景和背景",
    "2430": "请具体描述一下你需要的是什么",
    "2431": "你的反馈对我们提升更好的使用体验有着至关重要的帮助，确定要离开吗？",
    "2432": "关于查询速度问题",
    "2433": "关于使用的便利性问题",
    "2434": "关于查询查询网站问题",
    "2435": "关于缺陷问题",
    "2436": "大于5M图片不可上传",
    "2437": "网查应用内",
    "2438": "{}的评论已提交成功",
    "2439": "移入此区域显示「刷新」，刷新该文件夹内容",
    "2440": "存在筛选条件",
    "2441": "请输入标题关键字 以空格区分",
    "2442": "在“项目文档”中搜索",
    "2443": "在“底稿视图”中搜索",
    "2444": "在\"{}...\"中搜索",
    "2445": "在\"{}\"中搜索",
    "2446": "开始",
    "2447": "系统通知",
    "2448": "加急消息",
    "2449": "基础信息",
    "2450": "请输入姓名,最多可输入10字符",
    "2451": "请选择性别",
    "2452": "手机",
    "2453": "已绑定",
    "2454": "未绑定",
    "2455": "需前往[荣大科技-账号安全]进行修改",
    "2456": "立即绑定",
    "2457": "请输入手机号",
    "2458": "不对外显示号码",
    "2459": "请输入邮箱",
    "2460": "请输入公司名称",
    "2461": "请输入部门",
    "2462": "请输入职位",
    "2463": "姓名不能为空",
    "2464": "手机不能为空",
    "2465": "性别不能为空",
    "2466": "不允许输入\\\\符号",
    "2467": "修改个人信息成功",
    "2468": "原密码",
    "2469": "请输入原密码",
    "2470": "密码为6-18位数字与字母组合",
    "2471": "新密码",
    "2472": "请输入新密码",
    "2473": "确认密码",
    "2474": "请再次输入新密码",
    "2475": "修改密码成功！请重新登录",
    "2476": "权益信息",
    "2477": "权益包大集合",
    "2478": "荣大公司交付的权益包集合，无需再次付费即可一键充值使用",
    "2479": "支持对权益包进行多次转让他人后充值使用，也方便查看权益包的使用详情",
    "2480": "前往查看",
    "2481": "账号注销",
    "2482": "信息",
    "2483": "共计提审",
    "2484": "请输入选择",
    "2485": "请输入申请内容",
    "2486": "抄送方式",
    "2487": "审批通过后通知",
    "2488": "将会对底稿管理中选中目录发起审批",
    "2489": "将会对项目文档中选中文件发起审批",
    "2490": "将会对底稿视图中选中文件发起审批",
    "2491": "您暂无项目权限，不可发起审批",
    "2492": "请到底稿管理选择目录后发起审批",
    "2493": "请到项目文档/底稿管理选择文件后发起审批",
    "2494": "当前无选中{}",
    "2495": "归档文件无法发起审批",
    "2496": "所选文件中存在锁定文件，无法发起审批",
    "2497": "请先选择可审批的{}",
    "2498": "发起审批时，归档文件将自动过滤，确定要继续操作吗？",
    "2499": "仅审批通过的{}可发起修订审批",
    "2500": "仅审批通过的{}可发起审批，其他{}将自动过滤",
    "2501": "确认关闭",
    "2502": "请勾选想要删除的附件",
    "2503": "{}文件已存在",
    "2504": "请选部门",
    "2505": "提交审批成功",
    "2506": "收藏项目",
    "2507": "修改备注名",
    "2508": "独立项目窗口",
    "2509": "独立窗口数量已达上限",
    "2510": "最多可同时打开{}个独立窗口，请关闭其他已打开窗口再操作",
    "2511": "关联索引",
    "2512": "排序",
    "2513": "已选中",
    "2514": "项",
    "2515": "文件编辑模式支持「本地编辑」或「多人编辑」",
    "2516": "编辑预览说明",
    "2517": "本地编辑模式或多人编辑模式通过开关进行切换",
    "2518": "显示为仅可预览或不可预览的文件格式，不支持本地/多人编辑",
    "2519": "多人",
    "2520": "本地",
    "2521": "确定切换到「多人编辑模式」吗？",
    "2522": "该模式不兼容部分office功能，对文档排版格式有影响，确定继续切换吗？",
    "2523": "在线编辑模式",
    "2524": "本地编辑模式",
    "2525": "仅可预览",
    "2526": "不可预览",
    "2527": "正在保存",
    "2528": "备注{}条",
    "2529": "文件已删除，不能预览",
    "2530": "文件名已存在，新文件将以「{}」进行命名",
    "2531": "是否同步修改任务名称？",
    "2532": "请选择一个项目进行操作",
    "2533": "新建中",
    "2534": "{} 的 {}",
    "2535": "{}的{}",
    "2536": "的",
    "2537": "日志抄送人",
    "2538": "暂无抄送人",
    "2539": "复用该日志",
    "2540": "{}的{}日志",
    "2541": "确定要复用该日志吗？",
    "2542": "有正在编辑的草稿内容，当前操作将清空所有内容，确定要继续操作吗？",
    "2543": "复用日志",
    "2544": "数据获取失败，请关闭窗口重试",
    "2545": "暂无可复用的日志",
    "2546": "超出最大人数限制",
    "2547": "按组织架构选择",
    "2548": "按项目选择",
    "2549": "接口信息获取失败",
    "2550": "当前组织下无成员和子部门",
    "2551": "当前组织下无项目",
    "2552": "按组织结构选择",
    "2553": "{}({}人)",
    "2554": "按成员选择",
    "2555": "已存在",
    "2556": "底稿管理-{}审批意见页",
    "2557": "项目文档-文件审批意见页",
    "2558": "请选择{}",
    "2559": "将要删除文件",
    "2560": "关联文件位置",
    "2561": "被索引情况",
    "2562": "解锁中",
    "2563": "上锁时间",
    "2564": "锁类型",
    "2565": "锁定人",
    "2566": "正在解锁",
    "2567": "文件位置",
    "2568": "手动锁定",
    "2569": "异常锁定",
    "2570": "系统锁定",
    "2571": "我锁定的",
    "2572": "他人锁定的",
    "2573": "由项目成员进行手动锁定的文件",
    "2574": "系统检测到无人正在进行编辑，但文件并未正常解锁的情况，将被识别为文件异常锁定",
    "2575": "系统检测到正在进行编辑的文件，或因业务操作被系统锁定的文件不可被解锁",
    "2576": "操作失败",
    "2577": "本地编辑锁定",
    "2578": "多人编辑锁定",
    "2579": "搜索结果页不可以使用目录模板",
    "2580": "请先选择项目",
    "2581": "引用成功",
    "2582": "请选择想要复制的文件或文件夹",
    "2583": "当前无选中文件",
    "2584": "归档文件不可拖动剪切",
    "2585": "搜索结果页不允许剪切",
    "2586": "剪切成功",
    "2587": "已删除的文件可通过回收站还原，该文件已关联底稿文件",
    "2588": "关联的底稿文件将无法还原，确定要继续删除吗？",
    "2589": "确认要把文件放入回收站吗？文件已关联为底稿文件，将一同删除，删除的文件可随时在回收站里还原，但关联文件不能还原。",
    "2590": "正在删除...",
    "2591": "删除成功，删除的文档可以从「回收站」中恢复",
    "2592": "审批中的文件不能删除，请重新选择。",
    "2593": "审批通过的文件不能删除，请重新选择。",
    "2594": "确定要删除选中的内容吗？",
    "2595": "路径",
    "2596": "已删除的文件/文件夹可通过回收站还原，确定要继续删除吗？",
    "2597": "此操作仅删除底稿文件，项目文档中的原始文件不受影响，确定要继续删除吗？",
    "2598": "已删除的文件/文件夹将无法恢复，确定要继续删除吗？",
    "2599": "已添加至收藏！",
    "2600": "没有可上锁的数据",
    "2601": "批量上锁成功",
    "2602": "该文件已加锁",
    "2603": "审批中/审批通过的文件不可手动解锁！",
    "2604": "该文件已锁定，是否解锁",
    "2605": "确定要锁定该文件吗？",
    "2606": "锁定后，该文件无法编辑，确定要锁定吗？",
    "2607": "取消锁定",
    "2608": "搜索结果页不允许新建",
    "2609": "使用PDF Reader Pro与PDF Reader，未编辑内容关闭文件；",
    "2610": "使用浏览器编辑PDF文件；",
    "2611": "上述两种方式会造成文件锁定异常，需通过人工手动解除锁定。",
    "2612": "请确认本地已经安装pdf编辑软件",
    "2613": "未安装时进行本地编辑会造成文件锁定异常，需通过人工手动解除锁定",
    "2614": "继续编辑",
    "2615": "使用Numbers表格、Pages文稿、Keynote讲演进行单人本地编辑时，无法自动生成新版本，您可以采用手动上传的方式将本地已经编辑完成的文件进行上传。",
    "2616": "终止项目不支持引用模板",
    "2617": "搜索结果页不允许引用在线模板",
    "2618": "搜索结果页不允许粘贴",
    "2619": "请先选择目录",
    "2620": "请先复制粘贴文件",
    "2621": "请先复制文件或文件夹",
    "2622": "不能跨项目剪切",
    "2623": "请先复制文件",
    "2624": "正在剪切",
    "2625": "索引粘贴成功",
    "2626": "选择接收人",
    "2627": "仅支持勾选一个",
    "2628": "请先选择文件",
    "2629": "文件解锁成功",
    "2630": "无法对文件夹进行备注，请选择要备注的文件",
    "2631": "已选文件列表",
    "2632": "关键字",
    "2633": "包含以下全部关键字(以空格区分)",
    "2634": "请选择项目阶段",
    "2635": "已修订",
    "2636": "索引",
    "2637": "不可操作",
    "2638": "所在阶段",
    "2639": "所在目录",
    "2640": "生成",
    "2641": "底稿关联",
    "2642": "我的审批-{}审批-版本",
    "2643": "文件审批搜索结果",
    "2644": "有讨论的",
    "2645": "文件/文件夹",
    "2646": "目录修订审批",
    "2647": "{}搜索结果",
    "2648": "系统异常",
    "2649": "主工作台-我的审批-审批-审批记录",
    "2650": "请选择文件后点击版本",
    "2651": "请选择单个文件后点击版本",
    "2652": "当前无选中目录",
    "2653": "我的审批-{}审批-{}审批意见页",
    "2654": "该{}{},无法再进行审批",
    "2655": "该{}已被其他节点驳回,无法再进行审批",
    "2656": "请先选择可审批的目录",
    "2657": "已在其他审批中进行/审批通过的文件不能再进行审批，进行审批时将自动过滤。源文件及索引文件进行审批时，所有审批意见及审批状态将进行同步?",
    "2658": "已在其他审批中进行/审批通过的目录和本次未提审的待审批目录不能进行审批，进行审批时将自动过滤",
    "2659": "审批确认",
    "2660": "请先选择可审批的文件",
    "2661": "{}审批",
    "2662": "{}审批意见",
    "2663": "我的审批-{}审批-备注",
    "2664": "{}审批查询",
    "2665": "{}/{}/{}审批查询",
    "2666": "请选中{}后点击下载",
    "2667": "我的审批-{}审批",
    "2668": "当前无选中{}，请选择您要导出的{}",
    "2669": "我的审批-文件审批-文件审批搜索结果",
    "2670": "相关信息",
    "2671": "共计",
    "2672": "，已审",
    "2673": "个，待审",
    "2674": "去审",
    "2675": "）个",
    "2676": "节点审批",
    "2677": "文件修订审批意见",
    "2678": "目录修订审批意见",
    "2679": "转交",
    "2680": "请输入审批意见，最多输入1000字",
    "2681": "抄送人(抄送方式:整体审批完成后抄送)",
    "2682": "新建日程提醒",
    "2683": "我的审批-{}审批-节点审批-{}审批意见页",
    "2684": "所属行业",
    "2685": "成立时间",
    "2686": "联系电话",
    "2687": "所属部门",
    "2688": "团队信息",
    "2689": "借阅信息",
    "2690": "记录",
    "2691": "抄送人：",
    "2692": "级审批",
    "2693": "审批时间：",
    "2694": "审批文件",
    "2695": "文件审批记录",
    "2696": "平方根几号放假",
    "2697": "关联会议",
    "2698": "选择会议",
    "2699": "请选择会议",
    "2700": "我选中的会议",
    "2701": "新增会议",
    "2702": "取消关联提醒",
    "2703": "关联投票",
    "2704": "选择投票",
    "2705": "请选择投票",
    "2706": "我选中的投票",
    "2707": "新增投票",
    "2708": "取消投票关联提醒",
    "2709": "没有关联的投票",
    "2710": "请输入投票名称",
    "2711": "只能上传jpg/png文件，且不超过500kb",
    "2712": "转交人员",
    "2713": "请输入转交理由",
    "2714": "最多输入400字",
    "2715": "请选择转交人员",
    "2716": "会议主题内容不能为空",
    "2717": "会议类型内容不能为空",
    "2718": "结束时间不能为空",
    "2719": "参会人员不能为空",
    "2720": "取消成功!",
    "2721": "已取消",
    "2722": "是否取消该关联投票",
    "2723": "投票人员不能为空",
    "2724": "{}小时",
    "2725": "待审目录",
    "2726": "请选择审批结果",
    "2727": "请审批文件",
    "2728": "请审批目录",
    "2729": "当前附件全部未通过",
    "2730": "{}提醒您审批他的{}",
    "2731": "确认要撤销审批吗？",
    "2732": "主工作台",
    "2733": "撤销",
    "2734": "催办",
    "2735": "去审文件",
    "2736": "去审目录",
    "2737": "审批结果：",
    "2738": "此审批流程要求您要有关联的投票",
    "2739": "选择抄送人员",
    "2740": "您有未审批文件，请全部审批",
    "2741": "{} ：提醒您尽快审批关于{}{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为{}",
    "2742": "请输入名称",
    "2743": "请输入所属项目",
    "2744": "类型",
    "2745": "请选择类型",
    "2746": "事件名称",
    "2747": "事件类型",
    "2748": "日程抄送设置",
    "2749": "请选择抄送人",
    "2750": "新建日程",
    "2751": "默认通过站内信通知发送给对方，点击{}删除",
    "2752": "抄送我的日程",
    "2753": "周",
    "2754": "年",
    "2755": "开始前15分钟",
    "2756": "开始前1小时",
    "2757": "开始前3小时",
    "2758": "开始前1天",
    "2759": "结束日期不能小于于开始日期",
    "2760": "当前有草稿内容，是否要引用？",
    "2761": "内容不能为空",
    "2762": "七",
    "2763": "八",
    "2764": "九",
    "2765": "十",
    "2766": "十一",
    "2767": "十二",
    "2768": "从借阅成功起，借阅时限为{}小时超过借阅时限后",
    "2769": "借阅文件",
    "2770": "自动失效",
    "2771": "无法查看",
    "2772": "是否确定借阅？",
    "2773": "请输入项目编码",
    "2774": "访问来源",
    "2775": "移除全部已删除文件",
    "2776": "已取消收藏",
    "2777": "已移除",
    "2778": "待检验目录",
    "2779": "更改位置",
    "2780": "目录文件",
    "2781": "选择文件",
    "2782": "校验规则",
    "2783": "检验列: sheet 1, A列",
    "2784": "请选择待检验目录",
    "2785": "请选择目录文件",
    "2786": "文件大小超出限制，上限为10M",
    "2787": "目录检验中，完成后将推送系统消息，请稍后...",
    "2788": "待提取目录",
    "2789": "提取文件保存位置",
    "2790": "[Excel提取文件]",
    "2791": "请选择待提取目录",
    "2792": "请选择提取文件保存位置",
    "2793": "文件提取中，完成后将推送系统消息，请稍后...",
    "2794": "待导出目录",
    "2795": "导出内容",
    "2796": "文件 + 文件夹",
    "2797": "请选择待导出目录",
    "2798": "执行失败,请重试",
    "2799": "目录导出中，完成后将推送系统消息，请稍后...",
    "2800": "功能演示",
    "2801": "tips: 需等数分钟, 检验完成后将推送消息",
    "2802": "tips: 导出的目录只支持当下的50个层级",
    "2803": "检测",
    "2804": "提取",
    "2805": "检验",
    "2806": "创建群聊",
    "2807": "创建项目群",
    "2808": "不允许上传文件夹",
    "2809": "所要加入项目",
    "2810": "手机号邀请",
    "2811": "按群组邀请",
    "2812": "组织成员席位",
    "2813": "请输入正确格式的手机号",
    "2814": "请选择邀请人员",
    "2815": "搜索日志模板标题",
    "2816": "最近使用",
    "2817": "更多模板",
    "2818": "看成是大家",
    "2819": "看fsd",
    "2820": "擦第三方ads",
    "2821": "项目统计{}进度状态{}",
    "2822": "项目进度",
    "2823": "项目编号",
    "2824": "负责人",
    "2825": "整体完成度",
    "2826": "事项名称",
    "2827": "事项类型",
    "2828": "最新消息",
    "2829": "{}的项目日志",
    "2830": "的项目日志",
    "2831": "会议名称",
    "2832": "结束日期不能小于开始日期",
    "2833": "设置提醒后，有版本变动的文件将会在\"消息中心\"红点标记提醒！",
    "2834": "关闭提醒后，该文件对所有人的提醒均关闭！",
    "2835": "提醒人员",
    "2836": "添加人员",
    "2837": "添加角色",
    "2838": "选择的文件",
    "2839": "关闭提醒",
    "2840": "未选中要关闭的文件",
    "2841": "您已成功关闭本人设置的文件提醒",
    "2842": "请在提醒人员中添加人员或者角色",
    "2843": "请重新选择要提醒的文件",
    "2844": "文件设置提醒成功",
    "2845": "批量编辑关联",
    "2846": "选择要创建关联的文件",
    "2847": "请输入关键词搜索",
    "2848": "选择要关联的目标文件",
    "2849": "底稿文档",
    "2850": "右侧只能选择一个文件",
    "2851": "请选择要创建关联的文件",
    "2852": "请选择要关联的目标文件",
    "2853": "{}不能关联本身",
    "2854": "编辑底稿关联",
    "2855": "此文件已是锁定状态，不能再次添加",
    "2856": "文件不能关联本身",
    "2857": "已删除的文件不能被关联",
    "2858": "全文检索",
    "2859": "所在项目",
    "2860": "搜索条件不能为空",
    "2861": "首页",
    "2862": "借阅剩余时限",
    "2863": "已经到底了~",
    "2864": "{}分钟",
    "2865": "请选中数据进行下载或批量下载(注：锁定文件和不可操作文件是不能下载的)",
    "2866": "所选数据包含锁定文件不能删除",
    "2867": "此操作将永久删除该文件, 是否继续?",
    "2868": "数据过多正在删除中",
    "2869": "请选择数据进行删除",
    "2870": "此处删除只能删除单条",
    "2871": "所选数据包含锁定文件不能重命名",
    "2872": "名字不能为空",
    "2873": "所选数据包含锁定文件不能剪切",
    "2874": "当前选中有目录数据,暂不支持目录的剪切操作",
    "2875": "当前文件锁定成功",
    "2876": "当前文件未能锁定成功",
    "2877": "此处锁定只能锁定单条",
    "2878": "当前文件解锁成功",
    "2879": "当前文件未能解锁成功",
    "2880": "删除成功(含有文件锁或特殊文件是不允许删除的)",
    "2881": "编辑失败",
    "2882": "您确定要使用{}来当作文件的名字",
    "2883": "粘贴成功",
    "2884": "服务评价",
    "2885": "请对本次服务进行评价,您的评价有助于我们为您提供更好的服务!",
    "2886": "服务人员",
    "2887": "服务类型",
    "2888": "服务项目",
    "2889": "产品质量",
    "2890": "服务态度",
    "2891": "工作效率",
    "2892": "专业技能",
    "2893": "服务描述",
    "2894": "请您对本次服务做出评价最对200个字",
    "2895": "收藏此服务员",
    "2896": "匿名评价",
    "2897": "提交评价",
    "2898": "讨论对象",
    "2899": "待我执行({})",
    "2900": "抄送我的({})",
    "2901": "我创建的({})",
    "2902": "我完成的({})",
    "2903": "取消完成",
    "2904": "标记完成",
    "2905": "上次打开",
    "2906": "搜索任务名称",
    "2907": "请选择任务",
    "2908": "是否要取消完成所有选中的任务 是否继续?",
    "2909": "{}个任务取消成功，{}个任务取消失败",
    "2910": "确定要标记完成所有选中的任务吗？",
    "2911": "标记",
    "2912": "全部{}成功",
    "2913": "{}个任务{}成功，{}个任务{}失败",
    "2914": "任务不存在",
    "2915": "创建或加入组织",
    "2916": "创建属于你的组织，邀请成员一起协作办公，或点击",
    "2917": "现在，从新建一个项目开始全面使用智慧云吧",
    "2918": "开启智慧云文档、任务等核心功能，并邀请成员一起在线协作",
    "2919": "席位",
    "2920": "试用版永久免费",
    "2921": "拖拽排序",
    "2922": "可对任务进行拖拽排序",
    "2923": "更多选项",
    "2924": "Excel模板",
    "2925": "导入模板",
    "2926": "全部任务(含附件)",
    "2927": "仅任务总览",
    "2928": "导出任务",
    "2929": "默认顺序",
    "2930": "恢复任务初始顺序",
    "2931": "还原顺序",
    "2932": "还原移动前顺序",
    "2933": "高级",
    "2934": "请输入任务名称,多个请用空格隔开",
    "2935": "点击选择创建人",
    "2936": "请选择优先级",
    "2937": "请选择逾期状态",
    "2938": "请选择任务状态",
    "2939": "看板视图",
    "2940": "列表视图",
    "2941": "概览视图",
    "2942": "进行中",
    "2943": "逾期进行中",
    "2944": "逾期已完成",
    "2945": "待我执行",
    "2946": "我创建的",
    "2947": "我完成的",
    "2948": "全部任务(0)",
    "2949": "导入成功",
    "2950": "无任务导出",
    "2951": "网页端暂不支持此功能，请下载客户端操作",
    "2952": "定位项目群",
    "2953": "快速打开当前项目群聊窗口",
    "2954": "查看当前已打开项目任务",
    "2955": "邀请更多人员加入当前项目",
    "2956": "是否打开消息独立窗口并定位到对应的项目群？",
    "2957": "去到消息页面",
    "2958": "请先加入项目",
    "2959": "暂无邀请权限，请去联系项目创建人",
    "2960": "进行配置",
    "2961": "删除时间",
    "2962": "请选取至少一条数据",
    "2963": "您确定要还原文件？",
    "2964": "还原中...",
    "2965": "您确定要彻底删除文件？",
    "2966": "您确定要清空回收站？清空后文件将无法恢复",
    "2967": "清空回收站成功!",
    "2968": "个人网盘搜索结果页",
    "2969": "已使用空间",
    "2970": "没有说明",
    "2971": "版本名称",
    "2972": "请输入版本名称，如：1.0",
    "2973": "升级类型",
    "2974": "请选择升级类型",
    "2975": "不强制升级",
    "2976": "强制升级",
    "2977": "静默升级",
    "2978": "是否包含前端包",
    "2979": "请选择包含前端包",
    "2980": "不包含",
    "2981": "升级的环境",
    "2982": "请选择需要升级的环境",
    "2983": "开发",
    "2984": "测试",
    "2985": "产研",
    "2986": "正式",
    "2987": "环境ip",
    "2988": "跟升级环境对应的ip",
    "2989": "升级包地址",
    "2990": "请输入升级包地址",
    "2991": "pc升级验证",
    "2992": "请输入pc升级验证",
    "2993": "发布时间",
    "2994": "请选择产品的发布时间",
    "2995": "升级说明 {}",
    "2996": "请直接输入说明，注意不要输入序号！",
    "2997": "新增说明项",
    "2998": "删除此说明项",
    "2999": "请输入版本名称",
    "3000": "请选择是否包含前端包",
    "3001": "请选择升级环境",
    "3002": "请输入跟升级环境对应的ip",
    "3003": "请选择发布时间",
    "3004": "升级说明不允许为空",
    "3005": "此操作将永久删除该记录, 是否继续?",
    "3006": "升级标识",
    "3007": "请选择升级标识",
    "3008": "不用升级",
    "3009": "可选升级",
    "3010": "下载链接",
    "3011": "文案描述",
    "3012": "平台信息",
    "3013": "请选平台信息",
    "3014": "版本号不能为空",
    "3015": "版本号为数字",
    "3016": "升级标识不能为空",
    "3017": "下载链接不能为空",
    "3018": "文案描述不能为空",
    "3019": "平台信息不能为空",
    "3020": "新增失败",
    "3021": "下级部门",
    "3022": "增加子部门",
    "3023": "部门名称",
    "3024": "上移",
    "3025": "下移",
    "3026": "部门成员",
    "3027": "增加人员",
    "3028": "调整部门",
    "3029": "是否部门主管",
    "3030": "增加部门名称",
    "3031": "投资银行部",
    "3032": "请选择成员",
    "3033": "确定删除该人员吗?",
    "3034": "删除提示",
    "3035": "已经是第一条了",
    "3036": "已经是最后一条",
    "3037": "名称不能为空",
    "3038": "删除部门会删除部门下的所有子部门以及人员, 确定删除吗?",
    "3039": "新建流程",
    "3040": "版本管理",
    "3041": "流程名称",
    "3042": "变更理由",
    "3043": "是否为主版本",
    "3044": "主版本",
    "3045": "设置主版本",
    "3046": "人员配置",
    "3047": "审批人员",
    "3048": "选择用户",
    "3049": "无主管时，可由上级主管代批",
    "3050": "注：审批人为空时自动转交给管理员。",
    "3051": "已发布",
    "3052": "直接主管（1级主管）",
    "3053": "2级主管",
    "3054": "3级主管",
    "3055": "4级主管",
    "3056": "5级主管",
    "3057": "设置成功",
    "3058": "主版本不可删除",
    "3059": "此操作将永久删除该流程, 是否继续?",
    "3060": "请选择人员配置",
    "3061": "请选择指定用户",
    "3062": "请选择指定角色",
    "3063": "流程引擎搜索结果",
    "3064": "新增流程",
    "3065": "请输入关键词",
    "3066": "请先选择业务类型",
    "3067": "请选择一个业务类型",
    "3068": "开启流程审批",
    "3069": "关闭流程审批",
    "3070": "关联项目审批",
    "3071": "关闭关联项目审批",
    "3072": "描述",
    "3073": "流程",
    "3074": "保存并关闭",
    "3075": "未发布",
    "3076": "禁用中",
    "3077": "启用中",
    "3078": "去补充",
    "3079": "编辑流程",
    "3080": "请先保存修改内容",
    "3081": "只有状态为启用中的时候才能开启审批流程",
    "3082": "开启审批流程",
    "3083": "关闭审批流程",
    "3084": "只有开启审批流程之后才能开起关联项目审批",
    "3085": "开启关联审批流程",
    "3086": "关闭关联审批流程",
    "3087": "发布成功",
    "3088": "启用成功",
    "3089": "禁用成功",
    "3090": "所选审批人中{}",
    "3091": "{}抄送人中{}",
    "3092": "账号异常，请先编辑处理，否则将可能导致审批流程无法正常进行。",
    "3093": "流程图不完整无法启用该审核，请补充流程图",
    "3094": "业务类型内容不能为空",
    "3095": "审核类型内容不能为空！",
    "3096": "项目阶段内容不能为空",
    "3097": "保存成功",
    "3098": "请先选择流程",
    "3099": "请至少选择一条数据",
    "3100": "请先复制流程",
    "3101": "搜索角色",
    "3102": "无匹配数据",
    "3103": "创建角色副本",
    "3104": "可操作功能",
    "3105": "可访问数据",
    "3106": "项目数据",
    "3107": "客户数据",
    "3108": "个人日志数据",
    "3109": "数据源",
    "3110": "请先复制角色权限",
    "3111": "创建角色副本成功",
    "3112": "请选择权限",
    "3113": "请输入角色名称",
    "3114": "角色名称不能超过20个字符",
    "3115": "确定要删除选中的角色吗？",
    "3116": "请输入正确的角色名称",
    "3117": "选择时间",
    "3118": "日志分类",
    "3119": "请选日志分类",
    "3120": "底稿报送",
    "3121": "事件内容",
    "3122": "包含以下全部关键词（以空格区分）",
    "3123": "包含以下全部关键词（以空格区分",
    "3124": "操作用户",
    "3125": "请选择用户",
    "3126": "历史年度数据导出",
    "3127": "用户名",
    "3128": "选择导出年度",
    "3129": "导出当年",
    "3130": "上一年",
    "3131": "选择年",
    "3132": "工作",
    "3133": "用户",
    "3134": "检索日志",
    "3135": "组织消息",
    "3136": "开始时间不能晚于结束时间",
    "3137": "结束时间不能早于开始时间",
    "3138": "请输入开始日期",
    "3139": "请输入结束日期",
    "3140": "开始日期不能大于当前日期",
    "3141": "结束日期不能小于当前日期",
    "3142": "正在导出",
    "3143": "请选择时间",
    "3144": "角色",
    "3145": "退出时间",
    "3146": "拒绝",
    "3147": "荣大",
    "3148": "荣大-人员",
    "3149": "该操作将该成员取消邀请，是否继续？",
    "3150": "取消邀请成功",
    "3151": "员工名称",
    "3152": "请输入关键字,多个请用空格隔开",
    "3153": "离开时间",
    "3154": "已加入",
    "3155": "邀请中",
    "3156": "申请中",
    "3157": "请选择角色",
    "3158": "请选中人员",
    "3159": "系统异常, 请刷新页面",
    "3160": "同意成功",
    "3161": "拒绝成功",
    "3162": "修改人员",
    "3163": "请输入姓名",
    "3164": "姓名长度不能超过20",
    "3165": "请填写完整资料",
    "3166": "手机号格式错误，请重试",
    "3167": "身份证号不正确，请重试",
    "3168": "职位输入有误，职位名由汉字或字母组成",
    "3169": "确定要删除{}吗, 是否继续?",
    "3170": "收回独立窗口",
    "3171": "置顶独立窗口",
    "3172": "搜索组织",
    "3173": "上次组织",
    "3174": "全部组织",
    "3175": "项目名称:",
    "3176": "快速 「切换组织项目」 上线啦",
    "3177": "可切换其他组织下的项目",
    "3178": "变更时间",
    "3179": "变更日志",
    "3180": "客户姓名",
    "3181": "客户变更",
    "3182": "联系人变更",
    "3183": "新增",
    "3184": "项目关联",
    "3185": "推送列表",
    "3186": "推送名称",
    "3187": "执行状态",
    "3188": "推送内容",
    "3189": "用户名称",
    "3190": "请输入用户名称",
    "3191": "发送时间",
    "3192": "再次发送",
    "3193": "确定要再次发送此推送消息吗？",
    "3194": "发送成功",
    "3195": "发送中，合计发送 {} 人",
    "3196": "已完成，合计发送 {} 人，失败 {} 人",
    "3197": "正在导出!",
    "3198": "新建推送",
    "3199": "推送名称：",
    "3200": "请输入推送名称",
    "3201": "请输入创建人",
    "3202": "发送中，合计发送{}人",
    "3203": "已完成，合计发送{}人，失败{}人",
    "3204": "推送次数",
    "3205": "发送详情",
    "3206": "发送主体设置",
    "3207": "发送主体",
    "3208": "系统广告",
    "3209": "系统活动",
    "3210": "请选择接收人",
    "3211": "是否发送全局消息通知？",
    "3212": "发送链接为:",
    "3213": "内容设置",
    "3214": "请输入推送名称 (不超过字)",
    "3215": "有效期",
    "3216": "分享卡片标题",
    "3217": "分享卡片内容",
    "3218": "通知内容",
    "3219": "传输协议",
    "3220": "站内跳转",
    "3221": "ibsaasActivity.html为默认活动页路径",
    "3222": "APP推广通知",
    "3223": "请选择终端",
    "3224": "安卓",
    "3225": "立即创建",
    "3226": "图片未找到",
    "3227": "输入的字符不能超过{} 个！",
    "3228": "请输入系统通知信息",
    "3229": "输入的字符不能超过{}个！",
    "3230": "请输入有效期",
    "3231": "链接不能为空",
    "3232": "请输入卡片标题",
    "3233": "输入的字符不能超过200 个！",
    "3234": "请输入卡片内容",
    "3235": "活动类型下需要上传推广图片",
    "3236": "接收人设置（必选项）",
    "3237": "按用户推送",
    "3238": "用户姓名",
    "3239": "用户手机号",
    "3240": "添加一行",
    "3241": "批量导入",
    "3242": "按终端推送",
    "3243": "终端",
    "3244": "导入失败，请上传符合模板的Excel文件（xls、xlsx）",
    "3245": "当前文件过大，请上传4M以内的文件，格式包括xls、xlsx",
    "3246": "重新上传",
    "3247": "注销账号操作不可逆，请谨慎操作！",
    "3248": "永久注销当前账号，注销成功后该账号将无法使用，账号下的所有数据将被删除",
    "3249": "你正在申请注销当前账号。注销后，你将退出",
    "3250": "「荣大相关系列产品」且不能登录，如有付费产品也将一并取消，",
    "3251": "该账号将无法使用且无法恢复，账号下的所有数据也将被删除。确定要继续注销操作吗？",
    "3252": "注销前，请先移交或删除组织",
    "3253": "移交",
    "3254": "暂不注销",
    "3255": "继续注销",
    "3256": "已付费",
    "3257": "已到期",
    "3258": "账号注销成功",
    "3259": "账号注销失败",
    "3260": "移交项目",
    "3261": "删除项目",
    "3262": "删除项目后将无法恢复，请谨慎操作",
    "3263": "退出项目",
    "3264": "退出后将无法查看团队内容",
    "3265": "搜索目录",
    "3266": "文件名已存在，新文件将以{}进行命名",
    "3267": "确定要删除底稿目录吗？",
    "3268": "当前目录下的所有内容将被删除且无法恢复，确定要继续删除吗？",
    "3269": "全部下底稿上传不允许新建文件夹",
    "3270": "新建成功",
    "3271": "信息加载失败，请点击按钮重新加载",
    "3272": "搜索部门",
    "3273": "搜索职务",
    "3274": "手机号码",
    "3275": "电话",
    "3276": "新建客户联系人",
    "3277": "股东信息",
    "3278": "合作记录",
    "3279": "客户文档",
    "3280": "新增机构",
    "3281": "搜索机构编码/机构名称/机构简称",
    "3282": "新增中介机构",
    "3283": "机构信息",
    "3284": "请输入机构名称",
    "3285": "请输入机构简称",
    "3286": "请选择机构类型",
    "3287": "请输入机构联系人",
    "3288": "请输入客户负责人",
    "3289": "请输入联系电话",
    "3290": "传真",
    "3291": "请输入传真",
    "3292": "邮编",
    "3293": "请输入邮编",
    "3294": "办公地址",
    "3295": "请输入办公地址",
    "3296": "机构网址",
    "3297": "请输入机构网址",
    "3298": "机构简介",
    "3299": "请输入机构简介",
    "3300": "确定删除这条信息吗",
    "3301": "请输入机构编码,多个请用空格隔开",
    "3302": "请输入机构名称,多个请用空格隔开",
    "3303": "请输入机构简称,多个请用空格隔开",
    "3304": "请选择客户负责人",
    "3305": "请选择客户创建人",
    "3306": "机构名称内容不能为空",
    "3307": "机构简称内容不能为空",
    "3308": "机构类型内容不能为空",
    "3309": "机构联系人内容不能为空",
    "3310": "客户负责人内容不能为空",
    "3311": "联系电话内容不能为空",
    "3312": "邮箱格式错误",
    "3313": "传真有误，请重填",
    "3314": "我的企业客户",
    "3315": "搜索客户编码/客户名称",
    "3316": "行业(1级)",
    "3317": "行业(2级)",
    "3318": "行业(3级)",
    "3319": "行业(4级)",
    "3320": "新增企业客户",
    "3321": "请输入客户名称",
    "3322": "客户简称",
    "3323": "请输入客户简称",
    "3324": "上级客户",
    "3325": "请输入客户编码搜索",
    "3326": "客户地区",
    "3327": "请选择客户状态",
    "3328": "选择上市板块",
    "3329": "上市时间",
    "3330": "请输入法人代表",
    "3331": "请输入注册资本",
    "3332": "公司网址",
    "3333": "请输入公司网址",
    "3334": "公司简介",
    "3335": "请输入公司简介",
    "3336": "经营范围",
    "3337": "请输入经营范围",
    "3338": "请输入地址",
    "3339": "企业客户重名提示",
    "3340": "当前已存在{}个名称为{}的企业客户，客户创建人为{}",
    "3341": "是否创建同名新客户？客户编码将作为该客户唯一标识",
    "3342": "创建新客户",
    "3343": "请输入客户编码,多个请用空格隔开",
    "3344": "客户名称内容不能为空",
    "3345": "我的自然人客户",
    "3346": "新增自然人客户",
    "3347": "客户中文名：",
    "3348": "客户英文名：",
    "3349": "上级客户：",
    "3350": "客户地区：",
    "3351": "客户国籍：",
    "3352": "请选择客户国籍",
    "3353": "请选择客户学历",
    "3354": "客户性别：",
    "3355": "出生日期：",
    "3356": "身份证号码：",
    "3357": "请输入身份证号码",
    "3358": "客户状态：",
    "3359": "自然人重名提示",
    "3360": "硕士",
    "3361": "博士",
    "3362": "埃及",
    "3363": "爱尔兰",
    "3364": "奥地利",
    "3365": "澳大利亚",
    "3366": "巴西",
    "3367": "波兰",
    "3368": "德国",
    "3369": "俄国",
    "3370": "法国",
    "3371": "芬兰",
    "3372": "韩国",
    "3373": "荷兰",
    "3374": "加拿大",
    "3375": "美国",
    "3376": "尼日利亚",
    "3377": "挪威",
    "3378": "葡萄牙",
    "3379": "日本",
    "3380": "瑞国",
    "3381": "瑞士",
    "3382": "苏格兰",
    "3383": "泰国",
    "3384": "威尔士",
    "3385": "西班牙",
    "3386": "希腊",
    "3387": "新西兰",
    "3388": "以色列",
    "3389": "意大利",
    "3390": "印度",
    "3391": "英国",
    "3392": "客户中文名内容不能为空",
    "3393": "客户性别为必选",
    "3394": "客户出生日期不能为空",
    "3395": "客户身份证号错误",
    "3396": "客户类型内容不能为空",
    "3397": "联系电话不能为空",
    "3398": "客户状态内容不能为空",
    "3399": "原讨论文件都已删除",
    "3400": "请输入文件/文件夹名称",
    "3401": "位置",
    "3402": "删除人",
    "3403": "文件夹不支持预览",
    "3404": "确定要清空回收站吗？",
    "3405": "回收站清空后，文件将无法恢复，确定要清空吗？",
    "3406": "清空回收站成功！",
    "3407": "确定要还原文件吗？",
    "3408": "批量删除",
    "3409": "确定要彻底删除文件吗？",
    "3410": "讨论的文件已更换目录位置，请回到合集中选择单文件的定位",
    "3411": "成员管理",
    "3412": "已修改的内容尚未保存，确定退出吗",
    "3413": "文件已删除",
    "3414": "搜索客户名称",
    "3415": "拜访日期",
    "3416": "请输入拜访地点,多个请用空格隔开",
    "3417": "点击选择拜访人员",
    "3418": "请输入拜访形式,多个请用空格隔开",
    "3419": "请输入主要成果,多个请用空格隔开",
    "3420": "沟通让工作更高效",
    "3421": "群设置",
    "3422": "设置",
    "3423": "举报",
    "3424": "查询失败，请稍后重试！",
    "3425": "该公告已被{} 于{}年{}月{}日{}时删除！",
    "3426": "超过 20M 的图片请通过文件发送！",
    "3427": "请输入消息",
    "3428": "最多可输入{}个字符",
    "3429": "换行",
    "3430": "自动回复",
    "3431": "超出输入限制！",
    "3432": "Enter发送，Ctrl+Enter换行",
    "3433": "图片处理失败，请重新上传或使用文件方式发送！",
    "3434": "添加自定义",
    "3435": "添加自定义回复",
    "3436": "请输入自定义内容",
    "3437": "消息内容不能为空",
    "3438": "@成员",
    "3439": "截图",
    "3440": "「消息内文件」支持多人编辑啦！！",
    "3441": "上传文件后，点击多人编辑，即可实现多人实时协作，文件实时自动保存，快去试试吧！",
    "3442": "赞",
    "3443": "表情来源：",
    "3444": "屏幕截图",
    "3445": "截图并隐藏系统窗口",
    "3446": "当前已选择文件数",
    "3447": "文件已被撤回",
    "3448": "请输入群名称",
    "3449": "群组名最多输入50个字符",
    "3450": "群组名仅支持输入英文、汉字、数字",
    "3451": "被邀请人通过链接登录/注册后加入项目",
    "3452": "【荣大智慧云】",
    "3453": "“{}”邀请您加入项目“{}”,点击下方链接即可加入",
    "3454": "输入/粘贴手机号，多个可通过换行进行分隔，如",
    "3455": "切换",
    "3456": "目录视图",
    "3457": "个结果,第",
    "3458": "小提示",
    "3459": "如需针对单个目录进行审批操作，可将筛选项中的目录状态选为待审批后点击查询，即可对单个目录进行审批操作",
    "3460": "注：目录审批搜索结果页不会联动选中目录",
    "3461": "主工作台-我的审批-审批记录",
    "3462": "请选择审批人",
    "3463": "审批部门",
    "3464": "请选择审批部门",
    "3465": "请输入审批意见关键字",
    "3466": "节点审批结果",
    "3467": "所在位置",
    "3468": "审批人部门",
    "3469": "当前无选中文件，请选择您要导出的文件",
    "3470": "搜索项目名称{}申请内容",
    "3471": "暂无权限查看该页面",
    "3472": "提醒您尽快审批{}发起的{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "3473": "新增自然人",
    "3474": "搜索会议主题",
    "3475": "请输入会议类型",
    "3476": "选择导出项",
    "3477": "确定要删除该会议吗？",
    "3478": "删除成功!",
    "3479": "{}会议已被关联，不能删除",
    "3480": "不能删除",
    "3481": "确定删除所有会议？",
    "3482": "已选日志类型",
    "3483": "日志标题（可编辑）",
    "3484": "抄送人（必选）",
    "3485": "项目组成员",
    "3486": "提交日志",
    "3487": "编辑日志",
    "3488": "标题最大长度{}个字",
    "3489": "日志内容不能为空",
    "3490": "日志内容最大长度{}个字",
    "3491": "抄送人不能为空",
    "3492": "提交成功",
    "3493": "发送到人",
    "3494": "搜索日志标题",
    "3495": "与我相关",
    "3496": "我发出的",
    "3497": "暂无日志",
    "3498": "复用这篇日志模板",
    "3499": "分享",
    "3500": "分享这篇日志",
    "3501": "导出附件",
    "3502": "导出到项目文档",
    "3503": "日志修改记录",
    "3504": "暂无修改记录",
    "3505": "新增抄送人",
    "3506": "已经到底啦",
    "3507": "分享日志",
    "3508": "通讯录/我的日志",
    "3509": "工作台/我的日志",
    "3510": "评论{}的日志，可@组织成员，最多可输入{}个字",
    "3511": "确认要把文件放入回删除吗?",
    "3512": "可@组织成员，最多可输入{}个字",
    "3513": "请输入评论内容",
    "3514": "请输入回复内容",
    "3515": "修改日志",
    "3516": "临时草稿自动保存成功",
    "3517": "已自动同步未完成的草稿内容",
    "3518": "确定要引用远程草稿吗？",
    "3519": "检测到您有远程草稿，引用后，将直接使用远程草稿的内容，确定要引用吗？",
    "3520": "创建成功",
    "3521": "抄送人/组织/部门：{} 等{}个无效，已自动移除",
    "3522": "抄送人/组织/部门：{} 无效，已自动移除",
    "3523": "投票截止时间",
    "3524": "我参与的",
    "3525": "起：",
    "3526": "止：",
    "3527": "投票状态",
    "3528": "决策",
    "3529": "项目描述:",
    "3530": "投票编辑",
    "3531": "投票正在进行中不能删除",
    "3532": "确定删除所有选中投票",
    "3533": "请选择要删除选项",
    "3534": "确定删除已勾选投票？",
    "3535": "{}投票已被关联，不能删除",
    "3536": "项目信息（必填）",
    "3537": "（注：项目从属于组织）",
    "3538": "点击选择所属部门",
    "3539": "填写更多内容",
    "3540": "项目信息（选填）",
    "3541": "请输入项目简称",
    "3542": "上级项目",
    "3543": "请输入项目ID搜索",
    "3544": "请选择关联项目",
    "3545": "请选择项目地区",
    "3546": "开始阶段",
    "3547": "请选择开始阶段",
    "3548": "结束阶段",
    "3549": "请先选择业务类型和开始阶段",
    "3550": "请选择结束阶段",
    "3551": "计划开始时间",
    "3552": "计划结束时间",
    "3553": "标签信息（配置）",
    "3554": "引用标签",
    "3555": "完成创建",
    "3556": "温馨提示：",
    "3557": "智慧云用户将直接加入项目",
    "3558": "新用户将收到邀请加入短信",
    "3559": "请选组织名称",
    "3560": "请选择所属部门",
    "3561": "创建商机项目重复，是否继续创建?",
    "3562": "继续",
    "3563": "创建成功！",
    "3564": "新建组织",
    "3565": "填写更多信息（可选）",
    "3566": "智慧云用户将会直接加入项目，新用户将会收到邀请加入短信",
    "3567": "搜索审批流程名称",
    "3568": "新增标签",
    "3569": "字段名称、选项内容不能为空",
    "3570": "标签权限配置",
    "3571": "新增分类",
    "3572": "请输入分类名称（100字以内）",
    "3573": "编辑分类",
    "3574": "删除分类",
    "3575": "标签名称",
    "3576": "标签类型",
    "3577": "选项内容",
    "3578": "分类名称：",
    "3579": "该分类名称已存在，请重新填写",
    "3580": "编辑内容未保存，请保存后再进行其他操作",
    "3581": "该标签信息已被引用，不可删除",
    "3582": "确定要删除该标签分类吗？",
    "3583": "删除后，分类下的标签会一同删除，确定要继续操作吗？",
    "3584": "标签名称：",
    "3585": "请输入标签名称",
    "3586": "标签类型：",
    "3587": "选项内容：",
    "3588": "添加",
    "3589": "新增字段",
    "3590": "删除字段",
    "3591": "文本",
    "3592": "下拉列表",
    "3593": "数值",
    "3594": "不支持的类型",
    "3595": "勾选内容已被引用，不可删除",
    "3596": "输入角色名称进行搜索",
    "3597": "可编辑标签",
    "3598": "选择标签分类",
    "3599": "输入分类名称进行搜索",
    "3600": "已选标签分类",
    "3601": "您删除的内容已被项目应用，删除后不可恢复是否继续",
    "3602": "选择的标签分类不存在，请重新选择！",
    "3603": "当前归档阶段",
    "3604": "历史归档阶段",
    "3605": "当前归档时间",
    "3606": "当前归档人员",
    "3607": "借阅",
    "3608": "借阅人员",
    "3609": "请输入借阅人员",
    "3610": "借阅时长",
    "3611": "借阅内容",
    "3612": "查看全部文件",
    "3613": "确定要取消文件借阅吗？",
    "3614": "已填写的内容尚未提交，当前操作将清空所有内容，确定要继续操作吗？",
    "3615": "提醒您尽快审批关于{}，项目的底稿借阅审批,可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "3616": "从借阅成功起，借阅时限为{}小时，超过时限后，借阅文件将自动失效",
    "3617": "恢复项目",
    "3618": "恢复项目成功！",
    "3619": "终止原因",
    "3620": "请输入终止原因",
    "3621": "终止时间",
    "3622": "请选择终止日期",
    "3623": "终止说明",
    "3624": "导出组织内您可查看项目的人员信息，以Excel表格格式导出。",
    "3625": "会议发起成功",
    "3626": "是否要将该成员移出项目组？",
    "3627": "(移出项目后，被移出人员所上锁的文件将会解锁)",
    "3628": "加入时间",
    "3629": "邀请人",
    "3630": "已加入{}",
    "3631": "邀请中{}",
    "3632": "申请中{}",
    "3633": "搜索姓名",
    "3634": "角色：",
    "3635": "加入时间：",
    "3636": "离开时间：",
    "3637": "请先选择数据文件",
    "3638": "请选择项目中成员",
    "3639": "成员角色",
    "3640": "角色名称",
    "3641": "编辑角色",
    "3642": "上传文件/新版本",
    "3643": "文件复制",
    "3644": "文件剪切",
    "3645": "文件删除",
    "3646": "文件锁定",
    "3647": "角色名称不能为空",
    "3648": "保存!",
    "3649": "确定要删除该角色吗？",
    "3650": "删除该角色后，添加成员时将无法再选择该角色，确定要继续删除吗？",
    "3651": "修改成功!",
    "3652": "结果",
    "3653": "确定要删除选中的投票结果吗？",
    "3654": "确定删除所有选中投票？",
    "3655": "项目移交",
    "3656": "项目删除",
    "3657": "项目退出",
    "3658": "标签信息",
    "3659": "引用",
    "3660": "选择客户",
    "3661": "导入中",
    "3662": "发行档案",
    "3663": "导入",
    "3664": "下载模板",
    "3665": "发行人联系人",
    "3666": "发行人联系方式",
    "3667": "项目组联系人",
    "3668": "项目组联系方式",
    "3669": "主体资质",
    "3670": "债项资质",
    "3671": "申报规模{}亿{}",
    "3672": "核准规模{}亿{}",
    "3673": "批文有效期",
    "3674": "批复文号",
    "3675": "发行方式",
    "3676": "发行场地",
    "3677": "债券期限",
    "3678": "担保机构",
    "3679": "特殊条款",
    "3680": "往期债券",
    "3681": "承销团成员",
    "3682": "簿记室",
    "3683": "启动发行后填写",
    "3684": "债券简称",
    "3685": "银行间代码",
    "3686": "是否分期",
    "3687": "是否多品种发行",
    "3688": "已发行规模",
    "3689": "交易所代码",
    "3690": "本期债券规模（亿）",
    "3691": "质押代码",
    "3692": "询价利率区间{}%{}",
    "3693": "发行后剩余规模{}亿{}",
    "3694": "最终发行利率{}%{}",
    "3695": "受托期限",
    "3696": "参会委员",
    "3697": "时间类信息",
    "3698": "添加时间字段",
    "3699": "已被任务引用，不可编辑",
    "3700": "发行成功后填写",
    "3701": "是否为受托管理人",
    "3702": "抄送方式{}审批通过后通知",
    "3703": "请输入申请内容{}最多输入200字",
    "3704": "人员选择",
    "3705": "请输入登录密码",
    "3706": "移交创建人角色",
    "3707": "移交后退出项目并解锁上锁文件",
    "3708": "任务移交至新设创建人",
    "3709": "当前项目",
    "3710": "点击退出项目后，由您上锁的文件将会自动解锁",
    "3711": "请确认登录密码",
    "3712": "退出",
    "3713": "是否确认删除该项目",
    "3714": "利益冲突核查报告列表",
    "3715": "查看报告",
    "3716": "利益冲突比对结果报告",
    "3717": "项目发行信息档案导入",
    "3718": "共{}个导入项，其中{}个可成功导入",
    "3719": "发现以下{}个导入项不符合导入要求，将不会被导入",
    "3720": "导入项",
    "3721": "错误原因",
    "3722": "确定导入",
    "3723": "确定要导入发行档案信息吗",
    "3724": "导入信息后，当前信息将会被覆盖，确定要继续导入吗？",
    "3725": "赵达",
    "3726": "您没有权限查看该项目信息",
    "3727": "项目编码不能为空",
    "3728": "项目名称不能为空",
    "3729": "结束日期不能早于开始日期",
    "3730": "所属部门不能为空",
    "3731": "确定要删除项目吗?",
    "3732": "项目删除成功！",
    "3733": "密码错误",
    "3734": "移交创建人角色不能为空",
    "3735": "您当前为项目创建人，请先移交项目",
    "3736": "该成员不在项目中",
    "3737": "当前无审批通过的底稿文件可归档",
    "3738": "确定要选择客户吗？",
    "3739": "选择客户后将无法进行变更，确定继续操作吗？",
    "3740": "银行间代码不能超出20位数字，请修改。",
    "3741": "交易所代码不能超出20位数字，请修改。",
    "3742": "质押代码不能超出20位数字，请修改。",
    "3743": "询价利率区间格式不正确，请修改。",
    "3744": "批文有效期开始时间不能大于结束时间",
    "3745": "不能存在相同的时间字段，请修改",
    "3746": "文件类型不匹配",
    "3747": "请选择时间变量",
    "3748": "剩余一个时间变量项时不可删除",
    "3749": "以内的Excel导入(xls,xlsx)；",
    "3750": "第一列",
    "3751": "为任务标题，不能超过180字；",
    "3752": "单次",
    "3753": "最高支持导入",
    "3754": "条数据，超过 1000条的部分忽略不计；",
    "3755": "导入任务均为一级任务，不展示父子任务关系。",
    "3756": "导入任务",
    "3757": "正在识别中，请稍后...",
    "3758": "请选择导入阶段:",
    "3759": "可导入{}个，识别失败{}个",
    "3760": "注:1.如未处理识别失败的任务，失败任务将不会建立；2.如操作栏下关闭的任务将不会建立。",
    "3761": "创建任务",
    "3762": "上一个失败任务",
    "3763": "下一个失败任务",
    "3764": "未识别到任务名称，请检查本地文件",
    "3765": "请上传 4M 以内的Excel文件（xls、xlsx）。",
    "3766": "任务建立失败，请在操作栏下开启任务",
    "3767": "建立任务成功",
    "3768": "是否取消建立任务，确认后将不会建立任务。",
    "3769": "查看更多父级",
    "3770": "所属任务",
    "3771": "确定要删除该条消息吗？",
    "3772": "通知发行人或客户（适用于外部人员）",
    "3773": "请输入子任务名称，按回车键完成",
    "3774": "请输入子任务名称",
    "3775": "编辑任务",
    "3776": "收起设置",
    "3777": "任务设置",
    "3778": "新建任务",
    "3779": "当前内容已变更，是否保存修改？",
    "3780": "最大可同时打开10个任务选项卡，是否关闭其他选项卡",
    "3781": "注意事项",
    "3782": "请输入任务标题（必填）",
    "3783": "任务内容",
    "3784": "任务产出",
    "3785": "工时统计",
    "3786": "任务动态",
    "3787": "文件会上传到任务产出中",
    "3788": "任务完成",
    "3789": "请输入任务标题",
    "3790": "任务基本信息未保存，请保存后继续该操作",
    "3791": "确定要{}任务",
    "3792": "有项目时间信息不完整，是否完善?",
    "3793": "全部动态",
    "3794": "日常沟通({})",
    "3795": "任务日志",
    "3796": "正式回复({})",
    "3797": "不能重复选择",
    "3798": "搜索添加执行人",
    "3799": "搜索添加抄送人",
    "3800": "添加任务标签",
    "3801": "请选择时间变量（仅对债类业务有效）",
    "3802": "任务提醒",
    "3803": "请选择自定义时间",
    "3804": "每个月第{}天",
    "3805": "每个{}月第{}天",
    "3806": "每个月第{}个星期{}",
    "3807": "每个{}月第{}个星期{}",
    "3808": "每年{}",
    "3809": "每{}年",
    "3810": "到",
    "3811": "重复{}次",
    "3812": "每月第{}个",
    "3813": "每年{}{}日",
    "3814": "每周星期{}",
    "3815": "每月第{}星期{}",
    "3816": "每年{}日",
    "3817": "每{}天",
    "3818": "星期{}",
    "3819": "每周{}",
    "3820": "每{}周{}",
    "3821": "每月第{}天",
    "3822": "每{}月第{}天",
    "3823": "每月第x天",
    "3824": "每{}月第x天",
    "3825": "每月第{}个星期{}",
    "3826": "每{}月第{}个星期{}",
    "3827": "每月第x个星期第x天",
    "3828": "每{}月第x个星期第x天",
    "3829": "请输入内容，可@任务成员，最多可输入{}字",
    "3830": "超出{}字输入限制",
    "3831": "自定义周期",
    "3832": "重复频率",
    "3833": "重复时间",
    "3834": "无限重复",
    "3835": "终止于某天",
    "3836": "选择日期时间",
    "3837": "限定重复次数",
    "3838": "次后",
    "3839": "天",
    "3840": "个月",
    "3841": "请选择重复时间",
    "3842": "每{}天到{}结束",
    "3843": "每{}天，重复{}次",
    "3844": "星期{},",
    "3845": "每{}周的{}",
    "3846": "每{}周的{}{}结束",
    "3847": "每{}周的{}，重复{}次",
    "3848": "每{}月的第{}天",
    "3849": "每{}月的第{}天到{}结束",
    "3850": "每{}月的第{}天,重复{}次",
    "3851": "每{}月",
    "3852": "到{}结束",
    "3853": "每{}年,重复{}次",
    "3854": "完成任务",
    "3855": "完成任务(所有人)",
    "3856": "取消完成(所有人)",
    "3857": "你修改了任务名称，是否同步修改任务文件夹名称？",
    "3858": "文件夹名称重复时，自动重命名",
    "3859": "文件夹名称重复时，中止保存",
    "3860": "设置计划工时",
    "3861": "填报实际工时",
    "3862": "计划任务工时",
    "3863": "实际任务工时",
    "3864": "禁止更新他人工时",
    "3865": "计划工时/小时",
    "3866": "实际工时/小时",
    "3867": "填写本次新增工时",
    "3868": "将离开工时统计页面，已填写工时尚未保存，是否保存修改？",
    "3869": "不保存",
    "3870": "工时调整不可超过当前实际工时",
    "3871": "选择导入任务",
    "3872": "当前业务类型下的模板",
    "3873": "已选任务数量:",
    "3874": "确认导入",
    "3875": "该业务类型未配置任务模板",
    "3876": "请尝试以下两种操作",
    "3877": "导入Excel模板",
    "3878": "前往配置任务模板",
    "3879": "请联系管理员为该业务类型配置任务模板",
    "3880": "请先选择任务",
    "3881": "弹窗关闭",
    "3882": "暂无相关任务数据",
    "3883": "未添加执行人",
    "3884": "未添加抄送人",
    "3885": "未选择时间",
    "3886": "未添加标签",
    "3887": "未填写无任务内容",
    "3888": "未填写注意事项",
    "3889": "正式回复",
    "3890": "查看全部回复内容",
    "3891": "正在加载中......",
    "3892": "任务产出-文件",
    "3893": "暂不支持在浏览器中下载文件夹，请通过PC客户端下载",
    "3894": "确定要取消关联吗？",
    "3895": "取消关联后，该文件将从「任务产出」中移除，确定要取消关联码？",
    "3896": "取消关联成功",
    "3897": "全部完成",
    "3898": "批量编辑任务",
    "3899": "自定义时间",
    "3900": "重复周期",
    "3901": "添加子任务",
    "3902": "每年{}月{}日",
    "3903": "每{}年{}",
    "3904": "是否打开",
    "3905": "是否继续?",
    "3906": "已取消关闭",
    "3907": "请填写完整的时间",
    "3908": "是否保存任务基本信息并继续当前操作？是否继续?",
    "3909": "请输入任务名称",
    "3910": "确定要删除该{}吗, 是否继续?",
    "3911": "取消输入",
    "3912": "确定要关闭该{}吗, 是否继续?",
    "3913": "确定要删除该任务吗, 是否继续?",
    "3914": "确定要关闭该任务吗, 是否继续?",
    "3915": "关闭成功!",
    "3916": "全部编辑成功",
    "3917": "{}个任务编辑成功，{}个任务编辑失败",
    "3918": "可拖拽文件上传",
    "3919": "选中的文件取消关联后，将从「参考文件」中移除，确定要取消关联吗？",
    "3920": "取消关联后，该文件将从「参考文件」中移除，确定要取消关联吗？",
    "3921": "选择阶段导入",
    "3922": "新模板以增量的方式覆盖之前的模板, 是否继续?",
    "3923": "任务模板预览",
    "3924": "确认配置",
    "3925": "新导入任务“更新《{}》”与原有模板任务重名！",
    "3926": "新导入任务“更新",
    "3927": "”与原有模板任务重名！",
    "3928": "自动重命名",
    "3929": "跳过这个任务",
    "3930": "后续同名任务是否按此规则执行",
    "3931": "添加调查工具",
    "3932": "新增调查工具",
    "3933": "工具链接",
    "3934": "编辑调查工具",
    "3935": "确定要删除吗？",
    "3936": "已有标签",
    "3937": "暂无标签",
    "3938": "标签字数不超过{}个字，按回车保存",
    "3939": "选择标签颜色",
    "3940": "请给标签选择一个颜色",
    "3941": "修改记录",
    "3942": "请输入标签,标签字数不超过{}个字，按回车保存",
    "3943": "请输入标签,标签字数不超过{}个字",
    "3944": "任务数量",
    "3945": "包含不可见任务",
    "3946": "个任务",
    "3947": "最新修改人",
    "3948": "最新修改时间",
    "3949": "确定要删除该标签吗？",
    "3950": "标签被删除后，任务中引用的该标签将同时被删除，确定要继续删除吗？",
    "3951": "标签修改记录",
    "3952": "操作内容",
    "3953": "将本列表所有任务删除",
    "3954": "取消完成任务",
    "3955": "所属父任务",
    "3956": "确定要删除任务{}",
    "3957": "批量操作",
    "3958": "添加任务",
    "3959": "确定要{}所有选中的任务吗？",
    "3960": "已打开的任务",
    "3961": "关闭所有任务",
    "3962": "显示侧边栏",
    "3963": "自定义侧边栏",
    "3964": "对扩展工具栏是否满意",
    "3965": "感谢你的反馈",
    "3966": "发送反馈",
    "3967": "请告诉我们不满意的原因",
    "3968": "请对您的问题类型进行详细描述",
    "3969": "好的，感谢你的反馈！我们将尽快做出优化计划",
    "3970": "是什么原因",
    "3971": "请输入{}名称",
    "3972": "修改日期",
    "3973": "输入要搜索的目录",
    "3974": "目录名称",
    "3975": "增加子目录",
    "3976": "子目录名称",
    "3977": "请输入目录名称",
    "3978": "删除后，将删除该目录下的所有子目录,是否确认删除？",
    "3979": "请输入注意事项,最多输入200字",
    "3980": "输入内容不能为空",
    "3981": "目录列表",
    "3982": "搜索目录名称",
    "3983": "下载目录模板",
    "3984": "新增目录",
    "3985": "权限设置",
    "3986": "权限配置",
    "3987": "目录名称：",
    "3988": "所属业务类型：",
    "3989": "备注信息：",
    "3990": "请输入备注信息",
    "3991": "目录文件：",
    "3992": "注：1、请上传纯目录的word文件或符合要求的excel文件，上传目录文件后，系统将自动解析生产目录；",
    "3993": "2、如果您的目录模板含有特殊字符，引用前台时系统会自动帮您替换为空格或下划线；",
    "3994": "请先选择数据",
    "3995": "请先复制目录",
    "3996": "仅含项目阶段的业务类型可进行粘贴",
    "3997": "目录支持上传以下格式的文件：DOC、DOCX、XLS、XLSX，请重新上传正确格式的文件后重试",
    "3998": "该文件中未检测到目录信息",
    "3999": "操作过于频繁",
    "4000": "请上传纯目录的word文件或符合要求的excel文件",
    "4001": "已设置窗口正常大小",
    "4002": "已设置窗口最大化",
    "4003": "多窗体模式已开启",
    "4004": "当打开了一个或多个独立窗体时，你可以将不同项目之间的任何文件进行自由拖动",
    "4005": "提示：",
    "4006": "从当前项目文档或底稿视图向不同项目的窗体拖动文件时，操作结果做复制粘贴处理",
    "4007": "在开启消息独立窗口时，可以将当前列表中的文件直接拖拽至会话中",
    "4008": "数据权限范围",
    "4009": "组织内成员",
    "4010": "已选部门/成员",
    "4011": "所在部门成员个人日志",
    "4012": "指定部门/成员个人日志",
    "4013": "组织全部成员个人日志",
    "4014": "下列部门/成员不存在，已从「已选列表」中自动移除",
    "4015": "审批类型名称",
    "4016": "类型名称",
    "4017": "荣大科技",
    "4018": "是否确定删除？",
    "4019": "已经是第一条",
    "4020": "已经最后第一条",
    "4021": "请填写审批类型名称",
    "4022": "{}该审批类型，将同步{}该审批类型下的所有流程, 是否继续?",
    "4023": "添加配置",
    "4024": "借阅权限",
    "4025": "请输入时间",
    "4026": "当前时间不能删除",
    "4027": "借阅时间未配置，请进行配置",
    "4028": "时间不能为空",
    "4029": "当前输入的时间已存在",
    "4030": "添加类型",
    "4031": "会议类型配置",
    "4032": "投票类型配置",
    "4033": "请输入类型名称",
    "4034": "人数限制",
    "4035": "人员限制",
    "4036": "类型说明",
    "4037": "人,",
    "4038": "投票规则",
    "4039": "大于等于",
    "4040": "人同意允许通过",
    "4041": "人有条件通过为有条件通过",
    "4042": "人不同意不通过",
    "4043": "人暂缓表决为暂缓表决",
    "4044": "请输入人数",
    "4045": "人参加才能发起",
    "4046": "添加限制人员",
    "4047": "请输入类型说明",
    "4048": "同意（必选）",
    "4049": "不同意（必选）",
    "4050": "的人",
    "4051": "注：有条件通过默认为通过暂缓表决默认为不通过",
    "4052": "例：（2/3）的人大于等于同意允许通过",
    "4053": "例：有条件通过允许通过",
    "4054": "例：不同意为不通过",
    "4055": "例：暂缓表决为不通过",
    "4056": "例：（2/3）有条件通过允许通过",
    "4057": "例：（2/3）不同意为不通过",
    "4058": "例：（2/3）暂缓表决为不通过",
    "4059": "该角色已存在",
    "4060": "会议类型名称不能为空",
    "4061": "人员限制不能为空",
    "4062": "人数限制小于人员限制人数总和",
    "4063": "确定删除所选会议",
    "4064": "投票类型名称不能为空",
    "4065": "人数限制不能为空",
    "4066": "投票规则值不能为空",
    "4067": "投票规则最大值不能小于最小值",
    "4068": "确定删除所选投票",
    "4069": "通知方式配置",
    "4070": "短信通知",
    "4071": "启用短信通知",
    "4072": "注：启用前请确保系统已调试成功。",
    "4073": "邮件通知",
    "4074": "启用邮件通知",
    "4075": "保存失败",
    "4076": "获取失败",
    "4077": "业务类型名称",
    "4078": "退出编辑",
    "4079": "下载模版",
    "4080": "项目阶段名称",
    "4081": "请输入类型名称（50字以内）",
    "4082": "确定要导入业务类型吗?",
    "4083": "只能导入xls、xlsx格式文件",
    "4084": "导入成功！",
    "4085": "{}个阶段导入失败，阶段名称不可重复。",
    "4086": "{}个阶段导入失败，阶段名称不支持输入特殊字符。",
    "4087": "请填写阶段名称",
    "4088": "暂无数据可编辑",
    "4089": "成功修改",
    "4090": "{}该业务类型，将同步{}该业务类型下的所有流程和模板, 是否继续?",
    "4091": "角色基本信息",
    "4092": "修改项目角色",
    "4093": "选中角色已复制，请选择需要粘贴的角色",
    "4094": "确定删除选中的角色",
    "4095": "任务配置搜索结果",
    "4096": "新增任务模板",
    "4097": "模板名称",
    "4098": "包含以下全部关键字{}以空格区分{}",
    "4099": "请选择创建人",
    "4100": "新建任务模板",
    "4101": "任务模板名称",
    "4102": "注：如果您的任务模板含有特殊字符情况，引用前台时系统会自动帮您替换为空格或下划线处理；",
    "4103": "项目阶段类型",
    "4104": "任务模板名称：",
    "4105": "选择业务类型：",
    "4106": "请输入任务模板名称",
    "4107": "存在同名模板是否确定继续保存",
    "4108": "编辑任务模板",
    "4109": "此操作将永久删除该模板, 是否继续?",
    "4110": "任务导出",
    "4111": "是否保存已编辑内容",
    "4112": "暂无模板导出",
    "4113": "{}, 是否继续?",
    "4114": "导入后的阶段任务模板将会覆盖当前阶段模板，是否导入?",
    "4115": "请导入从系统中下载的模板！",
    "4116": "此操作将永久删除该任务, 是否继续?",
    "4117": "时间变量名称",
    "4118": "请输入时间变量名称",
    "4119": "查询结果为空",
    "4120": "添加时间变量",
    "4121": "编辑时间变量",
    "4122": "请先将时间规则禁用后删除",
    "4123": "是否要删除?",
    "4124": "启用成功！",
    "4125": "新增配置",
    "4126": "暂无权限查看，如有需要请联系组织管理员",
    "4127": "规则名称",
    "4128": "包含以下关键字",
    "4129": "IP地址",
    "4130": "受控人员",
    "4131": "请输入人员姓名",
    "4132": "请选择操作用户",
    "4133": "IP安全配置",
    "4134": "公网IP地址",
    "4135": "受控人数",
    "4136": "停用",
    "4137": "人员编辑",
    "4138": "IP编辑",
    "4139": "IP监控日志",
    "4140": "您确定删除该IP吗?",
    "4141": "字段管理",
    "4142": "注：关闭后，该字段在表单中将取消必填。",
    "4143": "文件解锁信息",
    "4144": "于{}手动解锁{}项文件",
    "4145": "锁定信息",
    "4146": "于",
    "4147": "进行编辑",
    "4148": "试用申请已提交成功，专员将在2个工作日内联系您",
    "4149": "智能网查将在5-10分钟内自动开通，请注意查收短信或智慧云消息",
    "4150": "分享有礼",
    "4151": "二维码邀请",
    "4152": "活动规则",
    "4153": "同一手机号视为同一用户，不重复赠送活动奖品",
    "4154": "邀请好友成功后，系统会自动发放奖品到您的账户中，请注意查收。",
    "4155": "活动时间",
    "4156": "权益有效期：自权益开通之日起{}内有效，过期作废，不予补偿。",
    "4157": "一旦发现有人邀请数据作弊，将清除其邀请数据，取消其获奖资格。",
    "4158": "还没有邀请成功的好友哦~",
    "4159": "奖励",
    "4160": "二维码复制失败，将下载该图片",
    "4161": "邀请二维码",
    "4162": "请输入联系人姓名",
    "4163": "人员属性",
    "4164": "请选择人员属性",
    "4165": "新增客户联系人",
    "4166": "固话",
    "4167": "身份证号",
    "4168": "是否为董监高",
    "4169": "新建联系人",
    "4170": "部门：",
    "4171": "请输入固话",
    "4172": "请输入职务",
    "4173": "证件号码",
    "4174": "请输入证件号码",
    "4175": "请输入手机号码",
    "4176": "编辑客户联系人",
    "4177": "确定删除该联系人",
    "4178": "全部人员",
    "4179": "董监高",
    "4180": "联系人名称内容不能为空",
    "4181": "部门内容不能为空",
    "4182": "固定电话内容不能为空",
    "4183": "固定电话仅支持\"-\"和数字，长度为{}字。",
    "4184": "是否为董监高为必选",
    "4185": "证件号码格式不正确,请重新输入",
    "4186": "职务内容不能为空",
    "4187": "手机号码内容不能为空",
    "4188": "手机号格式不正确,请重新输入",
    "4189": "邮箱格式不正确,请重新输入",
    "4190": "固定电话不能为空",
    "4191": "证件号码错误",
    "4192": "手机号码不能为空",
    "4193": "手机号码有误，请重填",
    "4194": "请选择客户地区",
    "4195": "服务团队",
    "4196": "信息跟踪人",
    "4197": "请输入信息跟踪人",
    "4198": "资本注册",
    "4199": "张三",
    "4200": "请输入正确格式",
    "4201": "客户中文名",
    "4202": "客户英文名",
    "4203": "客户国籍",
    "4204": "客户性别",
    "4205": "出生日期",
    "4206": "身份证号码",
    "4207": "请输入身份证号",
    "4208": "客户出生日期内容不能为空",
    "4209": "股东名称",
    "4210": "请输入股东名称",
    "4211": "股东类型",
    "4212": "请选择股东类型",
    "4213": "新增股东信息",
    "4214": "持股数",
    "4215": "持股比例",
    "4216": "身份证号/信用代码",
    "4217": "股东姓名",
    "4218": "请输入股东姓名",
    "4219": "持股数量",
    "4220": "请输入持股数",
    "4221": "信用代码",
    "4222": "请输入统一社会信用代码",
    "4223": "请输入持股比例",
    "4224": "编辑股东信息",
    "4225": "变更记录",
    "4226": "股东",
    "4227": "变更前股权比例",
    "4228": "变更后股权比例",
    "4229": "股权变更日期",
    "4230": "身份证号：",
    "4231": "信用代码：",
    "4232": "股东类型内容不能为空",
    "4233": "股东姓名内容不能为空",
    "4234": "持股数量内容不能为空",
    "4235": "身份证号/统一社会信用代码不能为空",
    "4236": "身份证号错误",
    "4237": "持股比例内容不能为空",
    "4238": "请输入拜访人员",
    "4239": "新增拜访记录",
    "4240": "新建拜访记录",
    "4241": "拜访记录信息",
    "4242": "拜访创建人",
    "4243": "请输入拜访形式",
    "4244": "请输入拜访地点",
    "4245": "请输入主要成果",
    "4246": "保 存",
    "4247": "编辑拜访记录",
    "4248": "确定删除该拜访记录吗",
    "4249": "拜访创建人内容不能为空",
    "4250": "拜访人员内容不能为空",
    "4251": "拜访开始日期内容不能为空",
    "4252": "拜访结束日期内容不能为空",
    "4253": "拜访地点内容不能为空",
    "4254": "主要成果内容不能为空",
    "4255": "结束时间不能小于开始时间",
    "4256": "暂不支持使用",
    "4257": "此应用当前仅支持智慧云Windows客户端使用，请先下载客户端",
    "4258": "项目创建时间",
    "4259": "新建{}",
    "4260": "请选择要下载的文件",
    "4261": "文件夹不支持下载，请选择下载文件",
    "4262": "文件夹不支持版本查看",
    "4263": "请选择要删除的数据",
    "4264": "已有相同名称的文件夹，是否以 {} 命名文件夹",
    "4265": "该文件已解锁",
    "4266": "文件回收站",
    "4267": "请选择要还原的文件",
    "4268": "已经到根目录了",
    "4269": "还原路径",
    "4270": "部分对象的还原路径不存在，请选择还原路径",
    "4271": "共{}个结果, 第{}个",
    "4272": "不能包含特殊字符\\\\/:*?\"<>|",
    "4273": "已有相同名称的目录，是否以 {} 命名目录",
    "4274": "已取消重命名",
    "4275": "今天也辛苦啦",
    "4276": "智慧云陪你一起努力",
    "4277": "历史沟通记录",
    "4278": "进入组织",
    "4279": "已同意",
    "4280": "立即沟通",
    "4281": "好的，现在创建",
    "4282": "进入群聊",
    "4283": "定位到文件",
    "4284": "文件创建失败",
    "4285": "定位到文件夹",
    "4286": "欢迎来到智慧云！",
    "4287": "已拒绝",
    "4288": "立即评价",
    "4289": "查看订单",
    "4290": "支付订单",
    "4291": "去处理",
    "4292": "去审批",
    "4293": "已评价",
    "4294": "请到主窗口操作此功能!",
    "4295": "已失效",
    "4296": "你不在当前项目中，暂不能查看项目信息",
    "4297": "输入关键词进行搜索",
    "4298": "关键词",
    "4299": "请输入关键词进行搜索(空格区分)",
    "4300": "可操作",
    "4301": "消息类型",
    "4302": "点击选择消息类型",
    "4303": "没有与搜索结果的匹配项，请检查你的搜索选项",
    "4304": "群成员",
    "4305": "以下所有人",
    "4306": "编辑群公告",
    "4307": "设为置顶",
    "4308": "删除群公告",
    "4309": "群公告置顶成功！",
    "4310": "操作失败，请稍后再试！",
    "4311": "确定要删除该篇公告吗？",
    "4312": "群公告删除成功！",
    "4313": "新建群公告",
    "4314": "超出输入限制",
    "4315": "若要插入链接，请以：http:// 或者 https:// 开头",
    "4316": "超出最大字符长度，请检查！",
    "4317": "群公告更新成功！",
    "4318": "群公告创建成功！",
    "4319": "确定要离开当前页面吗？",
    "4320": "已输入的内容尚未发布，当前操作将清空所有内容，确定要继续操作吗？",
    "4321": "设为",
    "4322": "没有更多啦",
    "4323": "暂无群公告",
    "4324": "群公告适用于发布群规、活动等信息",
    "4325": "更新于",
    "4326": "对方已注销账号",
    "4327": "发送消息",
    "4328": "机器人",
    "4329": "@消息",
    "4330": "选择群成员",
    "4331": "无可下载文件",
    "4332": "暂无聊天记录",
    "4333": "未找到相关记录",
    "4334": "下载全部",
    "4335": "讨论文件合集{}项",
    "4336": "[该消息类型本版本暂不支持查看（如需了解消息内容，请直接联系发送人）]",
    "4337": "您已被踢出此群聊",
    "4338": "文件不存在",
    "4339": "您已退出当前会话群，无法继续访问！",
    "4340": "讨论文件合集中所有文件版本/文件夹内容将实时与文档中内容进行同步更新",
    "4341": "选中另存为",
    "4342": "全部另存为",
    "4343": "选中下载",
    "4344": "全部下载",
    "4345": "该文件类型暂不支持预览，是否下载到本地？",
    "4346": "讨论文件合集已被撤回",
    "4347": "项目/群名称",
    "4348": "归属组织",
    "4349": "新建项目群已提交审批！",
    "4350": "确认提取聊天记录的归属组织",
    "4351": "选择归属组织",
    "4352": "选择组织",
    "4353": "请选择组织",
    "4354": "选择订单",
    "4355": "请选择订单",
    "4356": "提取成功!",
    "4357": "支持 “多个文件” 另存为啦！！",
    "4358": "选择多个文件，点击另存为即可实现多文件一起另存至同 一路径下（讨论文件合集暂不支持多选另存）",
    "4359": "逐条转发",
    "4360": "合并转发",
    "4361": "文件另存为",
    "4362": "提取聊天记录",
    "4363": "解散该群后，所有群成员将失去和群内成员的联系，同时该群的聊天图片、文件也将被删除！",
    "4364": "退出后，不会再接收此群聊消息！",
    "4365": "移除后，{}将无法收到该群聊的消息!",
    "4366": "解散群聊",
    "4367": "退出群聊",
    "4368": "移除群成员",
    "4369": "您不是群主，没有权限修改",
    "4370": "修改群信息成功",
    "4371": "备注名(仅自己可见)",
    "4372": "置顶聊天",
    "4373": "转让群主",
    "4374": "手机或邮箱邀请",
    "4375": "您已重复添加此内容！",
    "4376": "已邀请加入群聊",
    "4377": "邀请",
    "4378": "邀请群成员",
    "4379": "所要加入群聊",
    "4380": "分享群链接或群二维码，成员可快速加入群聊，快来试试吧！",
    "4381": "【荣大智慧云】“{}”邀请您加入讨论组“{}”，点击下方链接即可加入。",
    "4382": "被邀请人通过链接登录/注册后加入群聊",
    "4383": "【荣大智慧云】“{}”邀请您加入讨论组“{}”, 点击下方链接即可加入",
    "4384": "群主",
    "4385": "获取群成员信息失败",
    "4386": "群成员列表",
    "4387": "转让群主-选择成员",
    "4388": "选择超出限制",
    "4389": "讨论组邀请",
    "4390": "项目邀请",
    "4391": "组织邀请",
    "4392": "荣大智慧云外链分享的文件，请查看",
    "4393": "【荣大智慧云】“{}”邀请您加入“{}”，点击链接立即申请加入吧！用荣大智慧云开启高效协作模式。",
    "4394": "【荣大智慧云】“{}”邀请您加入项目“{}”，点击下方链接即可加入",
    "4395": "组织加入成功",
    "4396": "非项目成员无此功能权限",
    "4397": "你可以联系项目创建人索取项目编码，申请加入对应的项目。",
    "4398": "也可以由此项目负责人邀请您加入项目。",
    "4399": "去联系项目创建人",
    "4400": "源文件已不存在，无法操作此项",
    "4401": "源文件所在位置",
    "4402": "查看来源位置",
    "4403": "没有匹配到任何结果",
    "4404": "选择已达上限",
    "4405": "你有新消息",
    "4406": "回到底部",
    "4407": "加载更多",
    "4408": "我的群组",
    "4409": "暂无评论...",
    "4410": "日志详情",
    "4411": "最近会话",
    "4412": "给对方留言（字数限制{}字）",
    "4413": "超过选择限制，不能选择",
    "4414": "没有找到关于“{}”的结果",
    "4415": "请选择开通权益的组织",
    "4416": "（仅支持自己创建的组织）",
    "4417": "您还没有自己创建的组织，无法匹配权益，请先创建自己的组织",
    "4418": "立即开通",
    "4419": "文件上传进度",
    "4420": "文件未全部上传，是否关闭界面并清空上传列表?",
    "4421": "({}人)",
    "4422": "请添加成员",
    "4423": "创建群聊成功",
    "4424": "添加成员成功",
    "4425": "在这里通过「复用已有日志」进行新建",
    "4426": "输入评论 (Enter 发送)，支持@组织内成员",
    "4427": "输入文字超出最长限制",
    "4428": "邀请链接：",
    "4429": "返回列表",
    "4430": "点击选择会计师事务所",
    "4431": "点击选择律师事务所",
    "4432": "点击选择资产评估机构",
    "4433": "点击选择信用评级机构",
    "4434": "点击选择券商机构",
    "4435": "请选择客户名称",
    "4436": "请输入主营业务",
    "4437": "输入五字以上进行模糊搜索",
    "4438": "未选择",
    "4439": "未配置**",
    "4440": "请填写必填项",
    "4441": "关联内容",
    "4442": "请输入搜索内容",
    "4443": "完 成",
    "4444": "项目底稿",
    "4445": "下载选中",
    "4446": "上传文件到此目录下",
    "4447": "当前目录下禁止拖拽上传",
    "4448": "今天的任务",
    "4449": "未完成任务",
    "4450": "任务前置",
    "4451": "当前任务[{}], 是否依赖审批结果?",
    "4452": "当前任务[{}], 是否取消依赖批结果?",
    "4453": "取消关联后，该文件将从「任务产出」中移除，确定要取消关联吗？",
    "4454": "选中的文件取消关联后，将从「任务产出」中移除，确定要取消关联吗？",
    "4455": "是否依赖此关联任务",
    "4456": "是否取消依赖此任务",
    "4457": "当前任务[{}], {}?",
    "4458": "关闭本次",
    "4459": "不再查看",
    "4460": "了解全部权益",
    "4461": "日志模板",
    "4462": "发布模板",
    "4463": "创建模板",
    "4464": "子任务",
    "4465": "是否删除{}子任务",
    "4466": "所有动态",
    "4467": "是否删除",
    "4468": "日志类型状态内容不能为空",
    "4469": "是否要删除",
    "4470": "任务模板编辑",
    "4471": "每{}月的第{}",
    "4472": "每{}月的第{}到{}结束",
    "4473": "每{}月的第{},重复{}次",
    "4474": "{}到{}",
    "4475": "{},重复{}次",
    "4476": "图片不允许再次发送",
    "4477": "文件不允许再次发送",
    "4478": "视频不允许再次发送",
    "4479": "音频不允许再次发送",
    "4480": "注：最多导入200行，不含表头，格式同下表",
    "4481": "注：荣大服务人员不会占用席位",
    "4482": "总计",
    "4483": "剩余可用席位:",
    "4484": "席位扩容",
    "4485": "Excel导入",
    "4486": "全部清空",
    "4487": "新增一行",
    "4488": "新增十行",
    "4489": "单次最多添加{}人，现已满{}人，不可添加。",
    "4490": "未识别到人员信息，请检查本地文件!",
    "4491": "添加模板内容",
    "4492": "下拉",
    "4493": "标题不能为空，请输入标题",
    "4494": "必填",
    "4495": "非必填",
    "4496": "单选",
    "4497": "选项",
    "4498": "请输入选项内容",
    "4499": "添加选项",
    "4500": "请输入选项内容，最多{}字",
    "4501": "输入不能超过{}字",
    "4502": "请输入标题，最多{}字",
    "4503": "使用此模板时默认抄送人不可被移除",
    "4504": "模板标题（必填）",
    "4505": "模板标题不能为空，请输入模板标题",
    "4506": "请输入模板标题，最多{}字",
    "4507": "需填写者输入内容",
    "4508": "编辑IP配置，配置人员在登录组织时，需要受控的IP环境下才能登录组织",
    "4509": "第一步：设置受控的公网IP地址（共两步）",
    "4510": "请输入规则名称",
    "4511": "IP 地址",
    "4512": "IP 说明：",
    "4513": "编辑后默认启用",
    "4514": "创建后默认启用",
    "4515": "保存进入下一步",
    "4516": "未输入规则名称",
    "4517": "未输入正确 IP 地址",
    "4518": "IP白名单地址已存在",
    "4519": "操作失败，请稍后再试",
    "4520": "您确认关闭弹窗吗? 点击 \"确定\" 将不会保留数据",
    "4521": "编辑受控人员，该人员在登录组织时，需要受控的IP环境下才能登录组织",
    "4522": "第二步：选择受控人员，该人员在登录组织时，需要在第一步受控的IP环境下才能登录组织",
    "4523": "搜索人员名称",
    "4524": "人员展示区",
    "4525": "手机号(必填)",
    "4526": "工作单位",
    "4527": "注：组织信息中，组织归属人不受组织安全规则配置限制",
    "4528": "是否清除所有人员?",
    "4529": "编辑 IP 配置",
    "4530": "编辑人员配置",
    "4531": "提交的举报暂不支持取消或者撤回，举报理由请您如实客观选择",
    "4532": "请选择举报理由",
    "4533": "补充描述",
    "4534": "请输入 {} 字以内的描述",
    "4535": "补充描述不能为空",
    "4536": "上传图片证据",
    "4537": "图片证据如：聊天截图或其它证明材料",
    "4538": "图片数量已超过 {} 张，不能再继续上传",
    "4539": "最少需要上传一张图片",
    "4540": "图片数量最大不能超过 {} 张",
    "4541": "图片列表",
    "4542": "违反国家法律法规",
    "4543": "未获得权利人的合法授权",
    "4544": "泄露商业机密",
    "4545": "侵犯个人隐私",
    "4546": "垃圾信息骚扰",
    "4547": "涉及未成年人有害信息（涉及未成年人有害信息举报专区）",
    "4548": "提交失败，信息不能为空",
    "4549": "您已举报成功，管理员将会在后台进行处理",
    "4550": "当前上传图片已超过最大限制，最多上传 {} 张图片",
    "4551": "消息接收人列表",
    "4552": "人已读",
    "4553": "已收听",
    "4554": "选择的消息为特殊类型消息，暂不支持转发",
    "4555": "选择的消息中，{}等特殊类型的消息暂不支持转发",
    "4556": "语音消息、群公告、聊天记录、任务消息、讨论文件合集等特殊类型的消息暂不支持转发",
    "4557": "继续转发",
    "4558": "转发后不显示内容",
    "4559": "消息转发",
    "4560": "转发成功",
    "4561": "单次短信加急可选5人，超过后默认以站内信方式进行发送",
    "4562": "短信接收人",
    "4563": "仅应用内 加急",
    "4564": "应用内+短信 加急",
    "4565": "公司名称",
    "4566": "人已收听",
    "4567": "全部已收听",
    "4568": "{}人执行",
    "4569": "（已选中{}项，共{}项）",
    "4570": "等{}人执行",
    "4571": "新建Word",
    "4572": "新建Excel",
    "4573": "新建PPT",
    "4574": "备注名",
    "4575": "当前已存在{}个名称为{}身份证与当前填写身份证一致的自然人客户{},该客户创建人为{} ，是否创建同名新客户？客户编码将作为该客户唯一标识",
    "4576": "任务类型消息",
    "4577": "聊天记录合集",
    "4578": "日志类型消息",
    "4579": "语音消息",
    "4580": "图文消息",
    "4581": "{}（{}人）",
    "4582": "您的设备暂不支持此功能，请使用文件或文件夹分别上传",
    "4583": "系统将为您检测是否安装过荣大XB插件，如果您没有安装过XB插件将为您自动安装，待安装后需您继续点击对应项目“数据中心”进行业务类型操作。",
    "4584": "文件上传准备中，请耐心等待...",
    "4585": "系统设置",
    "4586": "搜索({})",
    "4587": "文件正在回传，请稍后重试",
    "4588": "传输列表工作中也可关闭继续其他操作",
    "4589": "任务概览暂不支持下载文件夹",
    "4590": "外链分享记录",
    "4591": "文件分享记录",
    "4592": "银行流水线上平台",
    "4593": "银行流水线上平台权限",
    "4594": "有权在项目文档与底稿视图中查看该项目下的所有外链分享记录，同时拥有取消全部外链分享的权限",
    "4595": "解析权限",
    "4596": "可以对文件进行开始解析、暂停解析",
    "4597": "校对权限",
    "4598": "可以对文件进行校对、导出",
    "4599": "外链权限设置",
    "4600": "通过分享外链的「权限设置」功能，可以设置外链的「过期时间」、「访问密码」、「下载权限」",
    "4601": "在「外链分享记录」中，可查看历史外链详情，也可取消分享",
    "4602": "分享二维码",
    "4603": "已含有访问密码，扫码后无需再次输入",
    "4604": "文件外链：",
    "4605": "{} 通过「荣大智慧云」将“{}”文件分享给你，点击链接进行查看。{}",
    "4606": "{} 通过「荣大智慧云」将“{}”等文件分享给你，点击链接进行查看。{}",
    "4607": "{}\\n访问密码：{}",
    "4608": "已经加载到底啦",
    "4609": "过期时间",
    "4610": "7天",
    "4611": "30天",
    "4612": "永久有效",
    "4613": "共选择{}个文件",
    "4614": "访问密码",
    "4615": "无访问密码",
    "4616": "有访问密码",
    "4617": "系统默认生成访问密码",
    "4618": "下载权限",
    "4619": "允许下载",
    "4620": "禁止下载",
    "4621": "获得该文档链接的用户都可访问分享的相关文档",
    "4622": "链接有效期：",
    "4623": "访问密码：",
    "4624": "所有获得链接的用户都可查看",
    "4625": "到期后将无法访问此链接",
    "4626": "确定要进入「银行流水线上平台」吗？",
    "4627": "取消该文件的外链分享",
    "4628": "文件外链",
    "4629": "分享时间",
    "4630": "取消分享",
    "4631": "确定要取消外链分享吗？",
    "4632": "取消后在该外链中将无法查看此文件，确定要继续操作吗？",
    "4633": "取消后链接将全部失效，确定要继续操作吗？",
    "4634": "取消成功",
    "4635": "{} 访问密码：{}",
    "4636": "请输入操作人名称",
    "4637": "取消全部外链分享",
    "4638": "数量",
    "4639": "取消分享后拥有该链接的用户将无法继续查看分享的文件内容，确定要取消分享吗？",
    "4640": "是否通知执行人和抄送人?",
    "4641": "因当前空间不足，导致文件上传失败，请清理空间后重试。",
    "4642": "港股翻译",
    "4643": "IT数据中台线上平台",
    "4644": "管理员权限",
    "4645": "可以对文档进行校对、预览",
    "4646": "预览校对权限",
    "4647": "可以对文件进行校对、编辑、预览、导出",
    "4648": "文件名称暂不支持查看",
    "4649": "确定要进入「港股翻译」平台吗？",
    "4650": "确定要进入「IT数据中台线上平台」吗？",
    "4651": "项目属性",
    "4652": "请选择项目属性",
    "4653": "标签变动记录",
    "4654": "产品到期提醒",
    "4655": "前往充值",
    "4656": "会议已删除",
    "4657": "投票已删除",
    "4658": "正在加载，请稍等",
    "4659": "排序设置",
    "4660": "按创建时间",
    "4661": "按项目名称",
    "4662": "排序顺序",
    "4663": "倒序",
    "4664": "正序",
    "4665": "评论成功",
    "4666": "确定要删除评论吗？",
    "4667": "删除后将无法恢复，确定要继续删除评论吗？",
    "4668": "回复成功",
    "4669": "选区内容已被删除",
    "4670": "当前多选不支持此操作，请选择单个文件以查看版本",
    "4671": "客户关系",
    "4672": "性格特征",
    "4673": "擅长行业",
    "4674": "综合评价",
    "4675": "请输入客户关系",
    "4676": "请输入性格特征",
    "4677": "请选择擅长行业",
    "4678": "交接时间",
    "4679": "有新内容上线，点击完成更新",
    "4680": "更新信息",
    "4681": "执业岗位",
    "4682": "修改头像",
    "4683": "上传头像",
    "4684": "客户关系不能为空",
    "4685": "性格特征不能为空",
    "4686": "擅长行业不能为空",
    "4687": "YYYY年M月D日",
    "4688": "处理完成map",
    "4689": "查看上下文",
    "4690": "查看全部评论",
    "4691": "输入评论，支持@组织内成员",
    "4692": "任务成员",
    "4693": "IT数据中台项目：项目开通线上流水校对功能和RPA穿行测试功能",
    "4694": "IT数据中台项目",
    "4695": "Enter 发送",
    "4696": "输入内容超出字符限制，请控制在200字符以内",
    "4697": "更新版本时，已上锁文件将自动过滤，不进行重命名或更新",
    "4698": "申请查看联系人方式",
    "4699": "已被拒绝",
    "4700": "已终止授权",
    "4701": "授权有效期",
    "4702": "授权消息",
    "4703": "请选择项目类型",
    "4704": "当前授权已由他人完成",
    "4705": "请选择交易场所",
    "4706": "是否存在效力期限内与该项目有关的负面执业声誉信息",
    "4707": "请输入发行人",
    "4708": "请输入保荐机构",
    "4709": "获取官网数据",
    "4710": "人工录入数据",
    "4711": "新建项目经历",
    "4712": "编辑项目经历",
    "4713": "板块",
    "4714": "确定要删除该项目经历吗？",
    "4715": "联系人姓名:",
    "4716": "举报类型",
    "4717": "举报说明",
    "4718": "盗版、未获得权利人的合法授权",
    "4719": "举报成功",
    "4720": "可使用只读打开。确定要继续预览打开吗？",
    "4721": "下载可查看完整文件。确定要继续预览打开吗？",
    "4722": "安全中心",
    "4723": "已认证",
    "4724": "认证已过期",
    "4725": "您的实名认证已通过，有效期为",
    "4726": "注：认证到期或信息变更时，需要重新认证",
    "4727": "证件类型",
    "4728": "身份证",
    "4729": "更新认证",
    "4730": "立即认证",
    "4731": "真实姓名",
    "4732": "解绑",
    "4733": "证件证号",
    "4734": "请输入真实姓名",
    "4735": "请输入证件证号",
    "4736": "证件证号格式不正确，请检查后重新输入",
    "4737": "台湾来往大陆通行证",
    "4738": "港澳来往大陆通行证",
    "4739": "护照",
    "4740": "认证成功",
    "4741": "设置实名认证",
    "4742": "为满足监管要求，保障共享文件服务的安全合规，请进行实名认证以解锁全部功能",
    "4743": "关闭弹框后将退出登录，确定要取消实名认证吗？",
    "4744": "账号保护",
    "4745": "认证有效期",
    "4746": "申诉举报",
    "4747": "投诉举报",
    "4748": "未认证",
    "4749": "已过期",
    "4750": "本地编辑将调用本地对应文件的编辑器打开",
    "4751": "显示为「仅可预览」或「不可预览」的文件格式，不支持本地编辑",
    "4752": "验证失败，请重试",
    "4753": "填写信息",
    "4754": "认证完成",
    "4755": "如有问题，请拨打咨询电话-",
    "4756": "完成时间",
    "4757": "已显示全部子任务",
    "4758": "共 {} 项文件已全部显示",
    "4759": "审核期间可正常使用系统",
    "4760": "根据国家监管机构下发的相关监管要求，您提交的手机号疑似虚拟号码，我们将对您提交的信息进行人工审核，在此期间，您可以正常使用系统，若有监管审核需要，我们会及时与您联系核验信息，请您知晓"

}